import { j as ur } from "./utils-BdNIfrGQ.js";
import { createContext as sr, useState as fr, useCallback as dr, useEffect as cr, useMemo as ye, useContext as pr } from "react";
import { u as $ } from "./index-CTUcNxiT.js";
import { g as er } from "./_commonjsHelpers-DaMA6jEr.js";
var U = {}, B = {}, W = {}, we;
function rr() {
  return we || (we = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return v;
      }
    });
    function v(n) {
      if (n = `${n}`, n === "0")
        return "0";
      if (/^[+-]?(\d+|\d*\.\d+)(e[+-]?\d+)?(%|\w+)?$/.test(n))
        return n.replace(/^[+-]?/, (o) => o === "-" ? "" : "-");
      let u = [
        "var",
        "calc",
        "min",
        "max",
        "clamp"
      ];
      for (const o of u)
        if (n.includes(`${o}(`))
          return `calc(${n} * -1)`;
    }
  })(W)), W;
}
var V = {}, _e;
function gr() {
  return _e || (_e = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return v;
      }
    });
    const v = [
      "preflight",
      "container",
      "accessibility",
      "pointerEvents",
      "visibility",
      "position",
      "inset",
      "isolation",
      "zIndex",
      "order",
      "gridColumn",
      "gridColumnStart",
      "gridColumnEnd",
      "gridRow",
      "gridRowStart",
      "gridRowEnd",
      "float",
      "clear",
      "margin",
      "boxSizing",
      "lineClamp",
      "display",
      "aspectRatio",
      "size",
      "height",
      "maxHeight",
      "minHeight",
      "width",
      "minWidth",
      "maxWidth",
      "flex",
      "flexShrink",
      "flexGrow",
      "flexBasis",
      "tableLayout",
      "captionSide",
      "borderCollapse",
      "borderSpacing",
      "transformOrigin",
      "translate",
      "rotate",
      "skew",
      "scale",
      "transform",
      "animation",
      "cursor",
      "touchAction",
      "userSelect",
      "resize",
      "scrollSnapType",
      "scrollSnapAlign",
      "scrollSnapStop",
      "scrollMargin",
      "scrollPadding",
      "listStylePosition",
      "listStyleType",
      "listStyleImage",
      "appearance",
      "columns",
      "breakBefore",
      "breakInside",
      "breakAfter",
      "gridAutoColumns",
      "gridAutoFlow",
      "gridAutoRows",
      "gridTemplateColumns",
      "gridTemplateRows",
      "flexDirection",
      "flexWrap",
      "placeContent",
      "placeItems",
      "alignContent",
      "alignItems",
      "justifyContent",
      "justifyItems",
      "gap",
      "space",
      "divideWidth",
      "divideStyle",
      "divideColor",
      "divideOpacity",
      "placeSelf",
      "alignSelf",
      "justifySelf",
      "overflow",
      "overscrollBehavior",
      "scrollBehavior",
      "textOverflow",
      "hyphens",
      "whitespace",
      "textWrap",
      "wordBreak",
      "borderRadius",
      "borderWidth",
      "borderStyle",
      "borderColor",
      "borderOpacity",
      "backgroundColor",
      "backgroundOpacity",
      "backgroundImage",
      "gradientColorStops",
      "boxDecorationBreak",
      "backgroundSize",
      "backgroundAttachment",
      "backgroundClip",
      "backgroundPosition",
      "backgroundRepeat",
      "backgroundOrigin",
      "fill",
      "stroke",
      "strokeWidth",
      "objectFit",
      "objectPosition",
      "padding",
      "textAlign",
      "textIndent",
      "verticalAlign",
      "fontFamily",
      "fontSize",
      "fontWeight",
      "textTransform",
      "fontStyle",
      "fontVariantNumeric",
      "lineHeight",
      "letterSpacing",
      "textColor",
      "textOpacity",
      "textDecoration",
      "textDecorationColor",
      "textDecorationStyle",
      "textDecorationThickness",
      "textUnderlineOffset",
      "fontSmoothing",
      "placeholderColor",
      "placeholderOpacity",
      "caretColor",
      "accentColor",
      "opacity",
      "backgroundBlendMode",
      "mixBlendMode",
      "boxShadow",
      "boxShadowColor",
      "outlineStyle",
      "outlineWidth",
      "outlineOffset",
      "outlineColor",
      "ringWidth",
      "ringColor",
      "ringOpacity",
      "ringOffsetWidth",
      "ringOffsetColor",
      "blur",
      "brightness",
      "contrast",
      "dropShadow",
      "grayscale",
      "hueRotate",
      "invert",
      "saturate",
      "sepia",
      "filter",
      "backdropBlur",
      "backdropBrightness",
      "backdropContrast",
      "backdropGrayscale",
      "backdropHueRotate",
      "backdropInvert",
      "backdropOpacity",
      "backdropSaturate",
      "backdropSepia",
      "backdropFilter",
      "transitionProperty",
      "transitionDelay",
      "transitionDuration",
      "transitionTimingFunction",
      "willChange",
      "contain",
      "content",
      "forcedColorAdjust"
    ];
  })(V)), V;
}
var N = {}, ke;
function mr() {
  return ke || (ke = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return v;
      }
    });
    function v(n, u) {
      return n === void 0 ? u : Array.isArray(n) ? n : [
        ...new Set(u.filter((a) => n !== !1 && n[a] !== !1).concat(Object.keys(n).filter((a) => n[a] !== !1)))
      ];
    }
  })(N)), N;
}
var I = {}, H = {}, j = { exports: {} }, Ae;
function tr() {
  if (Ae) return j.exports;
  Ae = 1;
  var e = String, v = function() {
    return { isColorSupported: !1, reset: e, bold: e, dim: e, italic: e, underline: e, inverse: e, hidden: e, strikethrough: e, black: e, red: e, green: e, yellow: e, blue: e, magenta: e, cyan: e, white: e, gray: e, bgBlack: e, bgRed: e, bgGreen: e, bgYellow: e, bgBlue: e, bgMagenta: e, bgCyan: e, bgWhite: e, blackBright: e, redBright: e, greenBright: e, yellowBright: e, blueBright: e, magentaBright: e, cyanBright: e, whiteBright: e, bgBlackBright: e, bgRedBright: e, bgGreenBright: e, bgYellowBright: e, bgBlueBright: e, bgMagentaBright: e, bgCyanBright: e, bgWhiteBright: e };
  };
  return j.exports = v(), j.exports.createColors = v, j.exports;
}
var Oe;
function ve() {
  return Oe || (Oe = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function v(l, r) {
      for (var p in r) Object.defineProperty(l, p, {
        enumerable: !0,
        get: r[p]
      });
    }
    v(e, {
      dim: function() {
        return t;
      },
      default: function() {
        return w;
      }
    });
    const n = /* @__PURE__ */ u(/* @__PURE__ */ tr());
    function u(l) {
      return l && l.__esModule ? l : {
        default: l
      };
    }
    let o = /* @__PURE__ */ new Set();
    function a(l, r, p) {
      typeof process < "u" && process.env.JEST_WORKER_ID || p && o.has(p) || (p && o.add(p), console.warn(""), r.forEach((b) => console.warn(l, "-", b)));
    }
    function t(l) {
      return n.default.dim(l);
    }
    const w = {
      info(l, r) {
        a(n.default.bold(n.default.cyan("info")), ...Array.isArray(l) ? [
          l
        ] : [
          r,
          l
        ]);
      },
      warn(l, r) {
        a(n.default.bold(n.default.yellow("warn")), ...Array.isArray(l) ? [
          l
        ] : [
          r,
          l
        ]);
      },
      risk(l, r) {
        a(n.default.bold(n.default.magenta("risk")), ...Array.isArray(l) ? [
          l
        ] : [
          r,
          l
        ]);
      }
    };
  })(H)), H;
}
var Ce;
function hr() {
  return Ce || (Ce = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const v = /* @__PURE__ */ n(ve());
    function n(a) {
      return a && a.__esModule ? a : {
        default: a
      };
    }
    function u({ version: a, from: t, to: w }) {
      v.default.warn(`${t}-color-renamed`, [
        `As of Tailwind CSS ${a}, \`${t}\` has been renamed to \`${w}\`.`,
        "Update your configuration file to silence this warning."
      ]);
    }
    const o = {
      inherit: "inherit",
      current: "currentColor",
      transparent: "transparent",
      black: "#000",
      white: "#fff",
      slate: {
        50: "#f8fafc",
        100: "#f1f5f9",
        200: "#e2e8f0",
        300: "#cbd5e1",
        400: "#94a3b8",
        500: "#64748b",
        600: "#475569",
        700: "#334155",
        800: "#1e293b",
        900: "#0f172a",
        950: "#020617"
      },
      gray: {
        50: "#f9fafb",
        100: "#f3f4f6",
        200: "#e5e7eb",
        300: "#d1d5db",
        400: "#9ca3af",
        500: "#6b7280",
        600: "#4b5563",
        700: "#374151",
        800: "#1f2937",
        900: "#111827",
        950: "#030712"
      },
      zinc: {
        50: "#fafafa",
        100: "#f4f4f5",
        200: "#e4e4e7",
        300: "#d4d4d8",
        400: "#a1a1aa",
        500: "#71717a",
        600: "#52525b",
        700: "#3f3f46",
        800: "#27272a",
        900: "#18181b",
        950: "#09090b"
      },
      neutral: {
        50: "#fafafa",
        100: "#f5f5f5",
        200: "#e5e5e5",
        300: "#d4d4d4",
        400: "#a3a3a3",
        500: "#737373",
        600: "#525252",
        700: "#404040",
        800: "#262626",
        900: "#171717",
        950: "#0a0a0a"
      },
      stone: {
        50: "#fafaf9",
        100: "#f5f5f4",
        200: "#e7e5e4",
        300: "#d6d3d1",
        400: "#a8a29e",
        500: "#78716c",
        600: "#57534e",
        700: "#44403c",
        800: "#292524",
        900: "#1c1917",
        950: "#0c0a09"
      },
      red: {
        50: "#fef2f2",
        100: "#fee2e2",
        200: "#fecaca",
        300: "#fca5a5",
        400: "#f87171",
        500: "#ef4444",
        600: "#dc2626",
        700: "#b91c1c",
        800: "#991b1b",
        900: "#7f1d1d",
        950: "#450a0a"
      },
      orange: {
        50: "#fff7ed",
        100: "#ffedd5",
        200: "#fed7aa",
        300: "#fdba74",
        400: "#fb923c",
        500: "#f97316",
        600: "#ea580c",
        700: "#c2410c",
        800: "#9a3412",
        900: "#7c2d12",
        950: "#431407"
      },
      amber: {
        50: "#fffbeb",
        100: "#fef3c7",
        200: "#fde68a",
        300: "#fcd34d",
        400: "#fbbf24",
        500: "#f59e0b",
        600: "#d97706",
        700: "#b45309",
        800: "#92400e",
        900: "#78350f",
        950: "#451a03"
      },
      yellow: {
        50: "#fefce8",
        100: "#fef9c3",
        200: "#fef08a",
        300: "#fde047",
        400: "#facc15",
        500: "#eab308",
        600: "#ca8a04",
        700: "#a16207",
        800: "#854d0e",
        900: "#713f12",
        950: "#422006"
      },
      lime: {
        50: "#f7fee7",
        100: "#ecfccb",
        200: "#d9f99d",
        300: "#bef264",
        400: "#a3e635",
        500: "#84cc16",
        600: "#65a30d",
        700: "#4d7c0f",
        800: "#3f6212",
        900: "#365314",
        950: "#1a2e05"
      },
      green: {
        50: "#f0fdf4",
        100: "#dcfce7",
        200: "#bbf7d0",
        300: "#86efac",
        400: "#4ade80",
        500: "#22c55e",
        600: "#16a34a",
        700: "#15803d",
        800: "#166534",
        900: "#14532d",
        950: "#052e16"
      },
      emerald: {
        50: "#ecfdf5",
        100: "#d1fae5",
        200: "#a7f3d0",
        300: "#6ee7b7",
        400: "#34d399",
        500: "#10b981",
        600: "#059669",
        700: "#047857",
        800: "#065f46",
        900: "#064e3b",
        950: "#022c22"
      },
      teal: {
        50: "#f0fdfa",
        100: "#ccfbf1",
        200: "#99f6e4",
        300: "#5eead4",
        400: "#2dd4bf",
        500: "#14b8a6",
        600: "#0d9488",
        700: "#0f766e",
        800: "#115e59",
        900: "#134e4a",
        950: "#042f2e"
      },
      cyan: {
        50: "#ecfeff",
        100: "#cffafe",
        200: "#a5f3fc",
        300: "#67e8f9",
        400: "#22d3ee",
        500: "#06b6d4",
        600: "#0891b2",
        700: "#0e7490",
        800: "#155e75",
        900: "#164e63",
        950: "#083344"
      },
      sky: {
        50: "#f0f9ff",
        100: "#e0f2fe",
        200: "#bae6fd",
        300: "#7dd3fc",
        400: "#38bdf8",
        500: "#0ea5e9",
        600: "#0284c7",
        700: "#0369a1",
        800: "#075985",
        900: "#0c4a6e",
        950: "#082f49"
      },
      blue: {
        50: "#eff6ff",
        100: "#dbeafe",
        200: "#bfdbfe",
        300: "#93c5fd",
        400: "#60a5fa",
        500: "#3b82f6",
        600: "#2563eb",
        700: "#1d4ed8",
        800: "#1e40af",
        900: "#1e3a8a",
        950: "#172554"
      },
      indigo: {
        50: "#eef2ff",
        100: "#e0e7ff",
        200: "#c7d2fe",
        300: "#a5b4fc",
        400: "#818cf8",
        500: "#6366f1",
        600: "#4f46e5",
        700: "#4338ca",
        800: "#3730a3",
        900: "#312e81",
        950: "#1e1b4b"
      },
      violet: {
        50: "#f5f3ff",
        100: "#ede9fe",
        200: "#ddd6fe",
        300: "#c4b5fd",
        400: "#a78bfa",
        500: "#8b5cf6",
        600: "#7c3aed",
        700: "#6d28d9",
        800: "#5b21b6",
        900: "#4c1d95",
        950: "#2e1065"
      },
      purple: {
        50: "#faf5ff",
        100: "#f3e8ff",
        200: "#e9d5ff",
        300: "#d8b4fe",
        400: "#c084fc",
        500: "#a855f7",
        600: "#9333ea",
        700: "#7e22ce",
        800: "#6b21a8",
        900: "#581c87",
        950: "#3b0764"
      },
      fuchsia: {
        50: "#fdf4ff",
        100: "#fae8ff",
        200: "#f5d0fe",
        300: "#f0abfc",
        400: "#e879f9",
        500: "#d946ef",
        600: "#c026d3",
        700: "#a21caf",
        800: "#86198f",
        900: "#701a75",
        950: "#4a044e"
      },
      pink: {
        50: "#fdf2f8",
        100: "#fce7f3",
        200: "#fbcfe8",
        300: "#f9a8d4",
        400: "#f472b6",
        500: "#ec4899",
        600: "#db2777",
        700: "#be185d",
        800: "#9d174d",
        900: "#831843",
        950: "#500724"
      },
      rose: {
        50: "#fff1f2",
        100: "#ffe4e6",
        200: "#fecdd3",
        300: "#fda4af",
        400: "#fb7185",
        500: "#f43f5e",
        600: "#e11d48",
        700: "#be123c",
        800: "#9f1239",
        900: "#881337",
        950: "#4c0519"
      },
      get lightBlue() {
        return u({
          version: "v2.2",
          from: "lightBlue",
          to: "sky"
        }), this.sky;
      },
      get warmGray() {
        return u({
          version: "v3.0",
          from: "warmGray",
          to: "stone"
        }), this.stone;
      },
      get trueGray() {
        return u({
          version: "v3.0",
          from: "trueGray",
          to: "neutral"
        }), this.neutral;
      },
      get coolGray() {
        return u({
          version: "v3.0",
          from: "coolGray",
          to: "gray"
        }), this.gray;
      },
      get blueGray() {
        return u({
          version: "v3.0",
          from: "blueGray",
          to: "slate"
        }), this.slate;
      }
    };
  })(I)), I;
}
var G = {}, Pe;
function vr() {
  return Pe || (Pe = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "defaults", {
      enumerable: !0,
      get: function() {
        return v;
      }
    });
    function v(n, ...u) {
      for (let t of u) {
        for (let w in t) {
          var o;
          !(n == null || (o = n.hasOwnProperty) === null || o === void 0) && o.call(n, w) || (n[w] = t[w]);
        }
        for (let w of Object.getOwnPropertySymbols(t)) {
          var a;
          !(n == null || (a = n.hasOwnProperty) === null || a === void 0) && a.call(n, w) || (n[w] = t[w]);
        }
      }
      return n;
    }
  })(G)), G;
}
var Y = {}, Se;
function br() {
  return Se || (Se = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "toPath", {
      enumerable: !0,
      get: function() {
        return v;
      }
    });
    function v(n) {
      if (Array.isArray(n)) return n;
      let u = n.split("[").length - 1, o = n.split("]").length - 1;
      if (u !== o)
        throw new Error(`Path is invalid. Has unbalanced brackets: ${n}`);
      return n.split(/\.(?![^\[]*\])|[\[\]]/g).filter(Boolean);
    }
  })(Y)), Y;
}
var X = {}, K = {}, Ee;
function be() {
  return Ee || (Ee = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function v(b, g) {
      for (var A in g) Object.defineProperty(b, A, {
        enumerable: !0,
        get: g[A]
      });
    }
    v(e, {
      flagEnabled: function() {
        return w;
      },
      issueFlagNotices: function() {
        return r;
      },
      default: function() {
        return p;
      }
    });
    const n = /* @__PURE__ */ o(/* @__PURE__ */ tr()), u = /* @__PURE__ */ o(ve());
    function o(b) {
      return b && b.__esModule ? b : {
        default: b
      };
    }
    let a = {
      optimizeUniversalDefaults: !1,
      generalizedModifiers: !0,
      disableColorOpacityUtilitiesByDefault: !1,
      relativeContentPathsByDefault: !1
    }, t = {
      future: [
        "hoverOnlyWhenSupported",
        "respectDefaultRingColorOpacity",
        "disableColorOpacityUtilitiesByDefault",
        "relativeContentPathsByDefault"
      ],
      experimental: [
        "optimizeUniversalDefaults",
        "generalizedModifiers"
      ]
    };
    function w(b, g) {
      if (t.future.includes(g)) {
        var A, x, O;
        return b.future === "all" || ((O = (x = b == null || (A = b.future) === null || A === void 0 ? void 0 : A[g]) !== null && x !== void 0 ? x : a[g]) !== null && O !== void 0 ? O : !1);
      }
      if (t.experimental.includes(g)) {
        var E, q, R;
        return b.experimental === "all" || ((R = (q = b == null || (E = b.experimental) === null || E === void 0 ? void 0 : E[g]) !== null && q !== void 0 ? q : a[g]) !== null && R !== void 0 ? R : !1);
      }
      return !1;
    }
    function l(b) {
      if (b.experimental === "all")
        return t.experimental;
      var g;
      return Object.keys((g = b?.experimental) !== null && g !== void 0 ? g : {}).filter((A) => t.experimental.includes(A) && b.experimental[A]);
    }
    function r(b) {
      if (process.env.JEST_WORKER_ID === void 0 && l(b).length > 0) {
        let g = l(b).map((A) => n.default.yellow(A)).join(", ");
        u.default.warn("experimental-flags-enabled", [
          `You have enabled experimental features: ${g}`,
          "Experimental features in Tailwind CSS are not covered by semver, may introduce breaking changes, and can change at any time."
        ]);
      }
    }
    const p = t;
  })(K)), K;
}
var Te;
function xr() {
  return Te || (Te = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "normalizeConfig", {
      enumerable: !0,
      get: function() {
        return a;
      }
    });
    const v = be(), n = /* @__PURE__ */ o(ve());
    function u(t) {
      if (typeof WeakMap != "function") return null;
      var w = /* @__PURE__ */ new WeakMap(), l = /* @__PURE__ */ new WeakMap();
      return (u = function(r) {
        return r ? l : w;
      })(t);
    }
    function o(t, w) {
      if (t && t.__esModule)
        return t;
      if (t === null || typeof t != "object" && typeof t != "function")
        return {
          default: t
        };
      var l = u(w);
      if (l && l.has(t))
        return l.get(t);
      var r = {}, p = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var b in t)
        if (b !== "default" && Object.prototype.hasOwnProperty.call(t, b)) {
          var g = p ? Object.getOwnPropertyDescriptor(t, b) : null;
          g && (g.get || g.set) ? Object.defineProperty(r, b, g) : r[b] = t[b];
        }
      return r.default = t, l && l.set(t, r), r;
    }
    function a(t) {
      if ((() => {
        if (t.purge || !t.content || !Array.isArray(t.content) && !(typeof t.content == "object" && t.content !== null))
          return !1;
        if (Array.isArray(t.content))
          return t.content.every((r) => typeof r == "string" ? !0 : !(typeof r?.raw != "string" || r?.extension && typeof r?.extension != "string"));
        if (typeof t.content == "object" && t.content !== null) {
          if (Object.keys(t.content).some((r) => ![
            "files",
            "relative",
            "extract",
            "transform"
          ].includes(r)))
            return !1;
          if (Array.isArray(t.content.files)) {
            if (!t.content.files.every((r) => typeof r == "string" ? !0 : !(typeof r?.raw != "string" || r?.extension && typeof r?.extension != "string")))
              return !1;
            if (typeof t.content.extract == "object") {
              for (let r of Object.values(t.content.extract))
                if (typeof r != "function")
                  return !1;
            } else if (!(t.content.extract === void 0 || typeof t.content.extract == "function"))
              return !1;
            if (typeof t.content.transform == "object") {
              for (let r of Object.values(t.content.transform))
                if (typeof r != "function")
                  return !1;
            } else if (!(t.content.transform === void 0 || typeof t.content.transform == "function"))
              return !1;
            if (typeof t.content.relative != "boolean" && typeof t.content.relative < "u")
              return !1;
          }
          return !0;
        }
        return !1;
      })() || n.default.warn("purge-deprecation", [
        "The `purge`/`content` options have changed in Tailwind CSS v3.0.",
        "Update your configuration file to eliminate this warning.",
        "https://tailwindcss.com/docs/upgrade-guide#configure-content-sources"
      ]), t.safelist = (() => {
        var r;
        let { content: p, purge: b, safelist: g } = t;
        return Array.isArray(g) ? g : Array.isArray(p?.safelist) ? p.safelist : Array.isArray(b?.safelist) ? b.safelist : Array.isArray(b == null || (r = b.options) === null || r === void 0 ? void 0 : r.safelist) ? b.options.safelist : [];
      })(), t.blocklist = (() => {
        let { blocklist: r } = t;
        if (Array.isArray(r)) {
          if (r.every((p) => typeof p == "string"))
            return r;
          n.default.warn("blocklist-invalid", [
            "The `blocklist` option must be an array of strings.",
            "https://tailwindcss.com/docs/content-configuration#discarding-classes"
          ]);
        }
        return [];
      })(), typeof t.prefix == "function")
        n.default.warn("prefix-function", [
          "As of Tailwind CSS v3.0, `prefix` cannot be a function.",
          "Update `prefix` in your configuration to be a string to eliminate this warning.",
          "https://tailwindcss.com/docs/upgrade-guide#prefix-cannot-be-a-function"
        ]), t.prefix = "";
      else {
        var l;
        t.prefix = (l = t.prefix) !== null && l !== void 0 ? l : "";
      }
      t.content = {
        relative: (() => {
          let { content: r } = t;
          return r?.relative ? r.relative : (0, v.flagEnabled)(t, "relativeContentPathsByDefault");
        })(),
        files: (() => {
          let { content: r, purge: p } = t;
          return Array.isArray(p) ? p : Array.isArray(p?.content) ? p.content : Array.isArray(r) ? r : Array.isArray(r?.content) ? r.content : Array.isArray(r?.files) ? r.files : [];
        })(),
        extract: (() => {
          let r = (() => {
            var g, A, x, O, E, q, R, T, F, L;
            return !((g = t.purge) === null || g === void 0) && g.extract ? t.purge.extract : !((A = t.content) === null || A === void 0) && A.extract ? t.content.extract : !((x = t.purge) === null || x === void 0 || (O = x.extract) === null || O === void 0) && O.DEFAULT ? t.purge.extract.DEFAULT : !((E = t.content) === null || E === void 0 || (q = E.extract) === null || q === void 0) && q.DEFAULT ? t.content.extract.DEFAULT : !((R = t.purge) === null || R === void 0 || (T = R.options) === null || T === void 0) && T.extractors ? t.purge.options.extractors : !((F = t.content) === null || F === void 0 || (L = F.options) === null || L === void 0) && L.extractors ? t.content.options.extractors : {};
          })(), p = {}, b = (() => {
            var g, A, x, O;
            if (!((g = t.purge) === null || g === void 0 || (A = g.options) === null || A === void 0) && A.defaultExtractor)
              return t.purge.options.defaultExtractor;
            if (!((x = t.content) === null || x === void 0 || (O = x.options) === null || O === void 0) && O.defaultExtractor)
              return t.content.options.defaultExtractor;
          })();
          if (b !== void 0 && (p.DEFAULT = b), typeof r == "function")
            p.DEFAULT = r;
          else if (Array.isArray(r))
            for (let { extensions: g, extractor: A } of r ?? [])
              for (let x of g)
                p[x] = A;
          else typeof r == "object" && r !== null && Object.assign(p, r);
          return p;
        })(),
        transform: (() => {
          let r = (() => {
            var b, g, A, x, O, E;
            return !((b = t.purge) === null || b === void 0) && b.transform ? t.purge.transform : !((g = t.content) === null || g === void 0) && g.transform ? t.content.transform : !((A = t.purge) === null || A === void 0 || (x = A.transform) === null || x === void 0) && x.DEFAULT ? t.purge.transform.DEFAULT : !((O = t.content) === null || O === void 0 || (E = O.transform) === null || E === void 0) && E.DEFAULT ? t.content.transform.DEFAULT : {};
          })(), p = {};
          return typeof r == "function" ? p.DEFAULT = r : typeof r == "object" && r !== null && Object.assign(p, r), p;
        })()
      };
      for (let r of t.content.files)
        if (typeof r == "string" && /{([^,]*?)}/g.test(r)) {
          n.default.warn("invalid-glob-braces", [
            `The glob pattern ${(0, n.dim)(r)} in your Tailwind CSS configuration is invalid.`,
            `Update it to ${(0, n.dim)(r.replace(/{([^,]*?)}/g, "$1"))} to silence this warning.`
          ]);
          break;
        }
      return t;
    }
  })(X)), X;
}
var J = {}, De;
function yr() {
  return De || (De = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return v;
      }
    });
    function v(n) {
      if (Object.prototype.toString.call(n) !== "[object Object]")
        return !1;
      const u = Object.getPrototypeOf(n);
      return u === null || Object.getPrototypeOf(u) === null;
    }
  })(J)), J;
}
var Z = {}, qe;
function wr() {
  return qe || (qe = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "cloneDeep", {
      enumerable: !0,
      get: function() {
        return v;
      }
    });
    function v(n) {
      return Array.isArray(n) ? n.map((u) => v(u)) : typeof n == "object" && n !== null ? Object.fromEntries(Object.entries(n).map(([u, o]) => [
        u,
        v(o)
      ])) : n;
    }
  })(Z)), Z;
}
var Q = {}, ee = {}, Re;
function _r() {
  return Re || (Re = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return v;
      }
    });
    function v(n) {
      return n.replace(/\\,/g, "\\2c ");
    }
  })(ee)), ee;
}
var re = {}, te = {}, ne = {}, Fe;
function kr() {
  return Fe || (Fe = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return v;
      }
    });
    const v = {
      aliceblue: [
        240,
        248,
        255
      ],
      antiquewhite: [
        250,
        235,
        215
      ],
      aqua: [
        0,
        255,
        255
      ],
      aquamarine: [
        127,
        255,
        212
      ],
      azure: [
        240,
        255,
        255
      ],
      beige: [
        245,
        245,
        220
      ],
      bisque: [
        255,
        228,
        196
      ],
      black: [
        0,
        0,
        0
      ],
      blanchedalmond: [
        255,
        235,
        205
      ],
      blue: [
        0,
        0,
        255
      ],
      blueviolet: [
        138,
        43,
        226
      ],
      brown: [
        165,
        42,
        42
      ],
      burlywood: [
        222,
        184,
        135
      ],
      cadetblue: [
        95,
        158,
        160
      ],
      chartreuse: [
        127,
        255,
        0
      ],
      chocolate: [
        210,
        105,
        30
      ],
      coral: [
        255,
        127,
        80
      ],
      cornflowerblue: [
        100,
        149,
        237
      ],
      cornsilk: [
        255,
        248,
        220
      ],
      crimson: [
        220,
        20,
        60
      ],
      cyan: [
        0,
        255,
        255
      ],
      darkblue: [
        0,
        0,
        139
      ],
      darkcyan: [
        0,
        139,
        139
      ],
      darkgoldenrod: [
        184,
        134,
        11
      ],
      darkgray: [
        169,
        169,
        169
      ],
      darkgreen: [
        0,
        100,
        0
      ],
      darkgrey: [
        169,
        169,
        169
      ],
      darkkhaki: [
        189,
        183,
        107
      ],
      darkmagenta: [
        139,
        0,
        139
      ],
      darkolivegreen: [
        85,
        107,
        47
      ],
      darkorange: [
        255,
        140,
        0
      ],
      darkorchid: [
        153,
        50,
        204
      ],
      darkred: [
        139,
        0,
        0
      ],
      darksalmon: [
        233,
        150,
        122
      ],
      darkseagreen: [
        143,
        188,
        143
      ],
      darkslateblue: [
        72,
        61,
        139
      ],
      darkslategray: [
        47,
        79,
        79
      ],
      darkslategrey: [
        47,
        79,
        79
      ],
      darkturquoise: [
        0,
        206,
        209
      ],
      darkviolet: [
        148,
        0,
        211
      ],
      deeppink: [
        255,
        20,
        147
      ],
      deepskyblue: [
        0,
        191,
        255
      ],
      dimgray: [
        105,
        105,
        105
      ],
      dimgrey: [
        105,
        105,
        105
      ],
      dodgerblue: [
        30,
        144,
        255
      ],
      firebrick: [
        178,
        34,
        34
      ],
      floralwhite: [
        255,
        250,
        240
      ],
      forestgreen: [
        34,
        139,
        34
      ],
      fuchsia: [
        255,
        0,
        255
      ],
      gainsboro: [
        220,
        220,
        220
      ],
      ghostwhite: [
        248,
        248,
        255
      ],
      gold: [
        255,
        215,
        0
      ],
      goldenrod: [
        218,
        165,
        32
      ],
      gray: [
        128,
        128,
        128
      ],
      green: [
        0,
        128,
        0
      ],
      greenyellow: [
        173,
        255,
        47
      ],
      grey: [
        128,
        128,
        128
      ],
      honeydew: [
        240,
        255,
        240
      ],
      hotpink: [
        255,
        105,
        180
      ],
      indianred: [
        205,
        92,
        92
      ],
      indigo: [
        75,
        0,
        130
      ],
      ivory: [
        255,
        255,
        240
      ],
      khaki: [
        240,
        230,
        140
      ],
      lavender: [
        230,
        230,
        250
      ],
      lavenderblush: [
        255,
        240,
        245
      ],
      lawngreen: [
        124,
        252,
        0
      ],
      lemonchiffon: [
        255,
        250,
        205
      ],
      lightblue: [
        173,
        216,
        230
      ],
      lightcoral: [
        240,
        128,
        128
      ],
      lightcyan: [
        224,
        255,
        255
      ],
      lightgoldenrodyellow: [
        250,
        250,
        210
      ],
      lightgray: [
        211,
        211,
        211
      ],
      lightgreen: [
        144,
        238,
        144
      ],
      lightgrey: [
        211,
        211,
        211
      ],
      lightpink: [
        255,
        182,
        193
      ],
      lightsalmon: [
        255,
        160,
        122
      ],
      lightseagreen: [
        32,
        178,
        170
      ],
      lightskyblue: [
        135,
        206,
        250
      ],
      lightslategray: [
        119,
        136,
        153
      ],
      lightslategrey: [
        119,
        136,
        153
      ],
      lightsteelblue: [
        176,
        196,
        222
      ],
      lightyellow: [
        255,
        255,
        224
      ],
      lime: [
        0,
        255,
        0
      ],
      limegreen: [
        50,
        205,
        50
      ],
      linen: [
        250,
        240,
        230
      ],
      magenta: [
        255,
        0,
        255
      ],
      maroon: [
        128,
        0,
        0
      ],
      mediumaquamarine: [
        102,
        205,
        170
      ],
      mediumblue: [
        0,
        0,
        205
      ],
      mediumorchid: [
        186,
        85,
        211
      ],
      mediumpurple: [
        147,
        112,
        219
      ],
      mediumseagreen: [
        60,
        179,
        113
      ],
      mediumslateblue: [
        123,
        104,
        238
      ],
      mediumspringgreen: [
        0,
        250,
        154
      ],
      mediumturquoise: [
        72,
        209,
        204
      ],
      mediumvioletred: [
        199,
        21,
        133
      ],
      midnightblue: [
        25,
        25,
        112
      ],
      mintcream: [
        245,
        255,
        250
      ],
      mistyrose: [
        255,
        228,
        225
      ],
      moccasin: [
        255,
        228,
        181
      ],
      navajowhite: [
        255,
        222,
        173
      ],
      navy: [
        0,
        0,
        128
      ],
      oldlace: [
        253,
        245,
        230
      ],
      olive: [
        128,
        128,
        0
      ],
      olivedrab: [
        107,
        142,
        35
      ],
      orange: [
        255,
        165,
        0
      ],
      orangered: [
        255,
        69,
        0
      ],
      orchid: [
        218,
        112,
        214
      ],
      palegoldenrod: [
        238,
        232,
        170
      ],
      palegreen: [
        152,
        251,
        152
      ],
      paleturquoise: [
        175,
        238,
        238
      ],
      palevioletred: [
        219,
        112,
        147
      ],
      papayawhip: [
        255,
        239,
        213
      ],
      peachpuff: [
        255,
        218,
        185
      ],
      peru: [
        205,
        133,
        63
      ],
      pink: [
        255,
        192,
        203
      ],
      plum: [
        221,
        160,
        221
      ],
      powderblue: [
        176,
        224,
        230
      ],
      purple: [
        128,
        0,
        128
      ],
      rebeccapurple: [
        102,
        51,
        153
      ],
      red: [
        255,
        0,
        0
      ],
      rosybrown: [
        188,
        143,
        143
      ],
      royalblue: [
        65,
        105,
        225
      ],
      saddlebrown: [
        139,
        69,
        19
      ],
      salmon: [
        250,
        128,
        114
      ],
      sandybrown: [
        244,
        164,
        96
      ],
      seagreen: [
        46,
        139,
        87
      ],
      seashell: [
        255,
        245,
        238
      ],
      sienna: [
        160,
        82,
        45
      ],
      silver: [
        192,
        192,
        192
      ],
      skyblue: [
        135,
        206,
        235
      ],
      slateblue: [
        106,
        90,
        205
      ],
      slategray: [
        112,
        128,
        144
      ],
      slategrey: [
        112,
        128,
        144
      ],
      snow: [
        255,
        250,
        250
      ],
      springgreen: [
        0,
        255,
        127
      ],
      steelblue: [
        70,
        130,
        180
      ],
      tan: [
        210,
        180,
        140
      ],
      teal: [
        0,
        128,
        128
      ],
      thistle: [
        216,
        191,
        216
      ],
      tomato: [
        255,
        99,
        71
      ],
      turquoise: [
        64,
        224,
        208
      ],
      violet: [
        238,
        130,
        238
      ],
      wheat: [
        245,
        222,
        179
      ],
      white: [
        255,
        255,
        255
      ],
      whitesmoke: [
        245,
        245,
        245
      ],
      yellow: [
        255,
        255,
        0
      ],
      yellowgreen: [
        154,
        205,
        50
      ]
    };
  })(ne)), ne;
}
var ze;
function nr() {
  return ze || (ze = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function v(x, O) {
      for (var E in O) Object.defineProperty(x, E, {
        enumerable: !0,
        get: O[E]
      });
    }
    v(e, {
      parseColor: function() {
        return g;
      },
      formatColor: function() {
        return A;
      }
    });
    const n = /* @__PURE__ */ u(kr());
    function u(x) {
      return x && x.__esModule ? x : {
        default: x
      };
    }
    let o = /^#([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i, a = /^#([a-f\d])([a-f\d])([a-f\d])([a-f\d])?$/i, t = /(?:\d+|\d*\.\d+)%?/, w = /(?:\s*,\s*|\s+)/, l = /\s*[,/]\s*/, r = /var\(--(?:[^ )]*?)(?:,(?:[^ )]*?|var\(--[^ )]*?\)))?\)/, p = new RegExp(`^(rgba?)\\(\\s*(${t.source}|${r.source})(?:${w.source}(${t.source}|${r.source}))?(?:${w.source}(${t.source}|${r.source}))?(?:${l.source}(${t.source}|${r.source}))?\\s*\\)$`), b = new RegExp(`^(hsla?)\\(\\s*((?:${t.source})(?:deg|rad|grad|turn)?|${r.source})(?:${w.source}(${t.source}|${r.source}))?(?:${w.source}(${t.source}|${r.source}))?(?:${l.source}(${t.source}|${r.source}))?\\s*\\)$`);
    function g(x, { loose: O = !1 } = {}) {
      var E, q;
      if (typeof x != "string")
        return null;
      if (x = x.trim(), x === "transparent")
        return {
          mode: "rgb",
          color: [
            "0",
            "0",
            "0"
          ],
          alpha: "0"
        };
      if (x in n.default)
        return {
          mode: "rgb",
          color: n.default[x].map((P) => P.toString())
        };
      let R = x.replace(a, (P, D, z, d, _) => [
        "#",
        D,
        D,
        z,
        z,
        d,
        d,
        _ ? _ + _ : ""
      ].join("")).match(o);
      if (R !== null)
        return {
          mode: "rgb",
          color: [
            parseInt(R[1], 16),
            parseInt(R[2], 16),
            parseInt(R[3], 16)
          ].map((P) => P.toString()),
          alpha: R[4] ? (parseInt(R[4], 16) / 255).toString() : void 0
        };
      var T;
      let F = (T = x.match(p)) !== null && T !== void 0 ? T : x.match(b);
      if (F === null)
        return null;
      let L = [
        F[2],
        F[3],
        F[4]
      ].filter(Boolean).map((P) => P.toString());
      return L.length === 2 && L[0].startsWith("var(") ? {
        mode: F[1],
        color: [
          L[0]
        ],
        alpha: L[1]
      } : !O && L.length !== 3 || L.length < 3 && !L.some((P) => /^var\(.*?\)$/.test(P)) ? null : {
        mode: F[1],
        color: L,
        alpha: (E = F[5]) === null || E === void 0 || (q = E.toString) === null || q === void 0 ? void 0 : q.call(E)
      };
    }
    function A({ mode: x, color: O, alpha: E }) {
      let q = E !== void 0;
      return x === "rgba" || x === "hsla" ? `${x}(${O.join(", ")}${q ? `, ${E}` : ""})` : `${x}(${O.join(" ")}${q ? ` / ${E}` : ""})`;
    }
  })(te)), te;
}
var Le;
function ar() {
  return Le || (Le = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function v(a, t) {
      for (var w in t) Object.defineProperty(a, w, {
        enumerable: !0,
        get: t[w]
      });
    }
    v(e, {
      withAlphaValue: function() {
        return u;
      },
      default: function() {
        return o;
      }
    });
    const n = nr();
    function u(a, t, w) {
      if (typeof a == "function")
        return a({
          opacityValue: t
        });
      let l = (0, n.parseColor)(a, {
        loose: !0
      });
      return l === null ? w : (0, n.formatColor)({
        ...l,
        alpha: t
      });
    }
    function o({ color: a, property: t, variable: w }) {
      let l = [].concat(t);
      if (typeof a == "function")
        return {
          [w]: "1",
          ...Object.fromEntries(l.map((p) => [
            p,
            a({
              opacityVariable: w,
              opacityValue: `var(${w}, 1)`
            })
          ]))
        };
      const r = (0, n.parseColor)(a);
      return r === null ? Object.fromEntries(l.map((p) => [
        p,
        a
      ])) : r.alpha !== void 0 ? Object.fromEntries(l.map((p) => [
        p,
        a
      ])) : {
        [w]: "1",
        ...Object.fromEntries(l.map((p) => [
          p,
          (0, n.formatColor)({
            ...r,
            alpha: `var(${w}, 1)`
          })
        ]))
      };
    }
  })(re)), re;
}
var ae = {}, ie = {}, Me;
function Ar() {
  return Me || (Me = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function v(P, D) {
      for (var z in D) Object.defineProperty(P, z, {
        enumerable: !0,
        get: D[z]
      });
    }
    v(e, {
      hasMathFn: function() {
        return F;
      },
      addWhitespaceAroundMathOperators: function() {
        return L;
      }
    });
    const n = 97, u = 122, o = 65, a = 90, t = 101, w = 69, l = 48, r = 57, p = 43, b = 45, g = 42, A = 47, x = 40, O = 41, E = 44, q = 32, R = 37, T = [
      "calc",
      "min",
      "max",
      "clamp",
      "mod",
      "rem",
      "sin",
      "cos",
      "tan",
      "asin",
      "acos",
      "atan",
      "atan2",
      "pow",
      "sqrt",
      "hypot",
      "log",
      "exp",
      "round"
    ];
    function F(P) {
      return P.indexOf("(") !== -1 && T.some((D) => P.includes(`${D}(`));
    }
    function L(P) {
      if (!T.some((c) => P.includes(c)))
        return P;
      let D = "", z = [], d = null, _ = null;
      for (let c = 0; c < P.length; c++) {
        let i = P.charCodeAt(c);
        if (i >= l && i <= r || d !== null && (i === R || i >= n && i <= u || i >= o && i <= a) ? d = c : (_ = d, d = null), i === x) {
          D += P[c];
          let m = c;
          for (let s = c - 1; s >= 0; s--) {
            let y = P.charCodeAt(s);
            if (y >= l && y <= r)
              m = s;
            else if (y >= n && y <= u)
              m = s;
            else
              break;
          }
          let h = P.slice(m, c);
          if (T.includes(h)) {
            z.unshift(!0);
            continue;
          } else if (z[0] && h === "") {
            z.unshift(!0);
            continue;
          }
          z.unshift(!1);
          continue;
        } else if (i === O)
          D += P[c], z.shift();
        else if (i === E && z[0]) {
          D += ", ";
          continue;
        } else {
          if (i === q && z[0] && D.charCodeAt(D.length - 1) === q)
            continue;
          if ((i === p || i === g || i === A || i === b) && z[0]) {
            let m = D.trimEnd(), h = m.charCodeAt(m.length - 1), s = m.charCodeAt(m.length - 2), y = P.charCodeAt(c + 1);
            if ((h === t || h === w) && s >= l && s <= r) {
              D += P[c];
              continue;
            } else if (h === p || h === g || h === A || h === b) {
              D += P[c];
              continue;
            } else if (h === x || h === E) {
              D += P[c];
              continue;
            } else P.charCodeAt(c - 1) === q ? D += `${P[c]} ` : /* Previous is a digit */ h >= l && h <= r || // Next is a digit
            y >= l && y <= r || // Previous is end of a function call (or parenthesized expression)
            h === O || // Next is start of a parenthesized expression
            y === x || // Next is an operator
            y === p || y === g || y === A || y === b || // Previous position was a value (+ unit)
            _ !== null && _ === c - 1 ? D += ` ${P[c]} ` : D += P[c];
          } else
            D += P[c];
        }
      }
      return D;
    }
  })(ie)), ie;
}
var oe = {}, le = {}, $e;
function xe() {
  return $e || ($e = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "splitAtTopLevelOnly", {
      enumerable: !0,
      get: function() {
        return v;
      }
    });
    function v(n, u) {
      let o = [], a = [], t = 0, w = !1;
      for (let l = 0; l < n.length; l++) {
        let r = n[l];
        o.length === 0 && r === u[0] && !w && (u.length === 1 || n.slice(l, l + u.length) === u) && (a.push(n.slice(t, l)), t = l + u.length), w = w ? !1 : r === "\\", r === "(" || r === "[" || r === "{" ? o.push(r) : (r === ")" && o[o.length - 1] === "(" || r === "]" && o[o.length - 1] === "[" || r === "}" && o[o.length - 1] === "{") && o.pop();
      }
      return a.push(n.slice(t)), a;
    }
  })(le)), le;
}
var je;
function Or() {
  return je || (je = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function v(l, r) {
      for (var p in r) Object.defineProperty(l, p, {
        enumerable: !0,
        get: r[p]
      });
    }
    v(e, {
      parseBoxShadowValue: function() {
        return t;
      },
      formatBoxShadowValue: function() {
        return w;
      }
    });
    const n = xe();
    let u = /* @__PURE__ */ new Set([
      "inset",
      "inherit",
      "initial",
      "revert",
      "unset"
    ]), o = /\ +(?![^(]*\))/g, a = /^-?(\d+|\.\d+)(.*?)$/g;
    function t(l) {
      return (0, n.splitAtTopLevelOnly)(l, ",").map((p) => {
        let b = p.trim(), g = {
          raw: b
        }, A = b.split(o), x = /* @__PURE__ */ new Set();
        for (let O of A)
          a.lastIndex = 0, !x.has("KEYWORD") && u.has(O) ? (g.keyword = O, x.add("KEYWORD")) : a.test(O) ? x.has("X") ? x.has("Y") ? x.has("BLUR") ? x.has("SPREAD") || (g.spread = O, x.add("SPREAD")) : (g.blur = O, x.add("BLUR")) : (g.y = O, x.add("Y")) : (g.x = O, x.add("X")) : g.color ? (g.unknown || (g.unknown = []), g.unknown.push(O)) : g.color = O;
        return g.valid = g.x !== void 0 && g.y !== void 0, g;
      });
    }
    function w(l) {
      return l.map((r) => r.valid ? [
        r.keyword,
        r.x,
        r.y,
        r.blur,
        r.spread,
        r.color
      ].filter(Boolean).join(" ") : r.raw).join(", ");
    }
  })(oe)), oe;
}
var Ue;
function ir() {
  return Ue || (Ue = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function v(f, k) {
      for (var S in k) Object.defineProperty(f, S, {
        enumerable: !0,
        get: k[S]
      });
    }
    v(e, {
      normalize: function() {
        return r;
      },
      normalizeAttributeSelectors: function() {
        return p;
      },
      url: function() {
        return b;
      },
      number: function() {
        return g;
      },
      percentage: function() {
        return A;
      },
      length: function() {
        return E;
      },
      lineWidth: function() {
        return R;
      },
      shadow: function() {
        return T;
      },
      color: function() {
        return F;
      },
      image: function() {
        return L;
      },
      gradient: function() {
        return D;
      },
      position: function() {
        return d;
      },
      familyName: function() {
        return _;
      },
      genericName: function() {
        return i;
      },
      absoluteSize: function() {
        return h;
      },
      relativeSize: function() {
        return y;
      }
    });
    const n = nr(), u = Ar(), o = Or(), a = xe();
    let t = [
      "min",
      "max",
      "clamp",
      "calc"
    ];
    function w(f) {
      return t.some((k) => new RegExp(`^${k}\\(.*\\)`).test(f));
    }
    const l = /* @__PURE__ */ new Set([
      // Concrete properties
      "scroll-timeline-name",
      "timeline-scope",
      "view-timeline-name",
      "font-palette",
      "anchor-name",
      "anchor-scope",
      "position-anchor",
      "position-try-options",
      // Shorthand properties
      "scroll-timeline",
      "animation-timeline",
      "view-timeline",
      "position-try"
    ]);
    function r(f, k = null, S = !0) {
      let C = k && l.has(k.property);
      return f.startsWith("--") && !C ? `var(${f})` : f.includes("url(") ? f.split(/(url\(.*?\))/g).filter(Boolean).map((M) => /^url\(.*?\)$/.test(M) ? M : r(M, k, !1)).join("") : (f = f.replace(/([^\\])_+/g, (M, lr) => lr + " ".repeat(M.length - 1)).replace(/^_/g, " ").replace(/\\_/g, "_"), S && (f = f.trim()), f = (0, u.addWhitespaceAroundMathOperators)(f), f);
    }
    function p(f) {
      return f.includes("=") && (f = f.replace(/(=.*)/g, (k, S) => {
        if (S[1] === "'" || S[1] === '"')
          return S;
        if (S.length > 2) {
          let C = S[S.length - 1];
          if (S[S.length - 2] === " " && (C === "i" || C === "I" || C === "s" || C === "S"))
            return `="${S.slice(1, -2)}" ${S[S.length - 1]}`;
        }
        return `="${S.slice(1)}"`;
      })), f;
    }
    function b(f) {
      return f.startsWith("url(");
    }
    function g(f) {
      return !isNaN(Number(f)) || w(f);
    }
    function A(f) {
      return f.endsWith("%") && g(f.slice(0, -1)) || w(f);
    }
    let O = `(?:${[
      "cm",
      "mm",
      "Q",
      "in",
      "pc",
      "pt",
      "px",
      "em",
      "ex",
      "ch",
      "rem",
      "lh",
      "rlh",
      "vw",
      "vh",
      "vmin",
      "vmax",
      "vb",
      "vi",
      "svw",
      "svh",
      "lvw",
      "lvh",
      "dvw",
      "dvh",
      "cqw",
      "cqh",
      "cqi",
      "cqb",
      "cqmin",
      "cqmax"
    ].join("|")})`;
    function E(f) {
      return f === "0" || new RegExp(`^[+-]?[0-9]*.?[0-9]+(?:[eE][+-]?[0-9]+)?${O}$`).test(f) || w(f);
    }
    let q = /* @__PURE__ */ new Set([
      "thin",
      "medium",
      "thick"
    ]);
    function R(f) {
      return q.has(f);
    }
    function T(f) {
      let k = (0, o.parseBoxShadowValue)(r(f));
      for (let S of k)
        if (!S.valid)
          return !1;
      return !0;
    }
    function F(f) {
      let k = 0;
      return (0, a.splitAtTopLevelOnly)(f, "_").every((C) => (C = r(C), C.startsWith("var(") ? !0 : (0, n.parseColor)(C, {
        loose: !0
      }) !== null ? (k++, !0) : !1)) ? k > 0 : !1;
    }
    function L(f) {
      let k = 0;
      return (0, a.splitAtTopLevelOnly)(f, ",").every((C) => (C = r(C), C.startsWith("var(") ? !0 : b(C) || D(C) || [
        "element(",
        "image(",
        "cross-fade(",
        "image-set("
      ].some((M) => C.startsWith(M)) ? (k++, !0) : !1)) ? k > 0 : !1;
    }
    let P = /* @__PURE__ */ new Set([
      "conic-gradient",
      "linear-gradient",
      "radial-gradient",
      "repeating-conic-gradient",
      "repeating-linear-gradient",
      "repeating-radial-gradient"
    ]);
    function D(f) {
      f = r(f);
      for (let k of P)
        if (f.startsWith(`${k}(`))
          return !0;
      return !1;
    }
    let z = /* @__PURE__ */ new Set([
      "center",
      "top",
      "right",
      "bottom",
      "left"
    ]);
    function d(f) {
      let k = 0;
      return (0, a.splitAtTopLevelOnly)(f, "_").every((C) => (C = r(C), C.startsWith("var(") ? !0 : z.has(C) || E(C) || A(C) ? (k++, !0) : !1)) ? k > 0 : !1;
    }
    function _(f) {
      let k = 0;
      return (0, a.splitAtTopLevelOnly)(f, ",").every((C) => (C = r(C), C.startsWith("var(") ? !0 : C.includes(" ") && !/(['"])([^"']+)\1/g.test(C) || /^\d/g.test(C) ? !1 : (k++, !0))) ? k > 0 : !1;
    }
    let c = /* @__PURE__ */ new Set([
      "serif",
      "sans-serif",
      "monospace",
      "cursive",
      "fantasy",
      "system-ui",
      "ui-serif",
      "ui-sans-serif",
      "ui-monospace",
      "ui-rounded",
      "math",
      "emoji",
      "fangsong"
    ]);
    function i(f) {
      return c.has(f);
    }
    let m = /* @__PURE__ */ new Set([
      "xx-small",
      "x-small",
      "small",
      "medium",
      "large",
      "x-large",
      "xx-large",
      "xxx-large"
    ]);
    function h(f) {
      return m.has(f);
    }
    let s = /* @__PURE__ */ new Set([
      "larger",
      "smaller"
    ]);
    function y(f) {
      return s.has(f);
    }
  })(ae)), ae;
}
var ue = {}, Be;
function Cr() {
  return Be || (Be = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "backgroundSize", {
      enumerable: !0,
      get: function() {
        return u;
      }
    });
    const v = ir(), n = xe();
    function u(o) {
      let a = [
        "cover",
        "contain"
      ];
      return (0, n.splitAtTopLevelOnly)(o, ",").every((t) => {
        let w = (0, n.splitAtTopLevelOnly)(t, "_").filter(Boolean);
        return w.length === 1 && a.includes(w[0]) ? !0 : w.length !== 1 && w.length !== 2 ? !1 : w.every((l) => (0, v.length)(l) || (0, v.percentage)(l) || l === "auto");
      });
    }
  })(ue)), ue;
}
var We;
function Pr() {
  return We || (We = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function v(d, _) {
      for (var c in _) Object.defineProperty(d, c, {
        enumerable: !0,
        get: _[c]
      });
    }
    v(e, {
      updateAllClasses: function() {
        return r;
      },
      asValue: function() {
        return g;
      },
      parseColorFormat: function() {
        return O;
      },
      asColor: function() {
        return q;
      },
      asLookupValue: function() {
        return R;
      },
      typeMap: function() {
        return F;
      },
      coerceValue: function() {
        return D;
      },
      getMatchingTypes: function() {
        return z;
      }
    });
    const n = /* @__PURE__ */ l(_r()), u = ar(), o = ir(), a = /* @__PURE__ */ l(rr()), t = Cr(), w = be();
    function l(d) {
      return d && d.__esModule ? d : {
        default: d
      };
    }
    function r(d, _) {
      d.walkClasses((c) => {
        c.value = _(c.value), c.raws && c.raws.value && (c.raws.value = (0, n.default)(c.raws.value));
      });
    }
    function p(d, _) {
      if (!A(d))
        return;
      let c = d.slice(1, -1);
      if (_(c))
        return (0, o.normalize)(c);
    }
    function b(d, _ = {}, c) {
      let i = _[d];
      if (i !== void 0)
        return (0, a.default)(i);
      if (A(d)) {
        let m = p(d, c);
        return m === void 0 ? void 0 : (0, a.default)(m);
      }
    }
    function g(d, _ = {}, { validate: c = () => !0 } = {}) {
      var i;
      let m = (i = _.values) === null || i === void 0 ? void 0 : i[d];
      return m !== void 0 ? m : _.supportsNegativeValues && d.startsWith("-") ? b(d.slice(1), _.values, c) : p(d, c);
    }
    function A(d) {
      return d.startsWith("[") && d.endsWith("]");
    }
    function x(d) {
      let _ = d.lastIndexOf("/"), c = d.lastIndexOf("[", _), i = d.indexOf("]", _);
      return d[_ - 1] === "]" || d[_ + 1] === "[" || c !== -1 && i !== -1 && c < _ && _ < i && (_ = d.lastIndexOf("/", c)), _ === -1 || _ === d.length - 1 ? [
        d,
        void 0
      ] : A(d) && !d.includes("]/[") ? [
        d,
        void 0
      ] : [
        d.slice(0, _),
        d.slice(_ + 1)
      ];
    }
    function O(d) {
      if (typeof d == "string" && d.includes("<alpha-value>")) {
        let _ = d;
        return ({ opacityValue: c = 1 }) => _.replace(/<alpha-value>/g, c);
      }
      return d;
    }
    function E(d) {
      return (0, o.normalize)(d.slice(1, -1));
    }
    function q(d, _ = {}, { tailwindConfig: c = {} } = {}) {
      var i;
      if (((i = _.values) === null || i === void 0 ? void 0 : i[d]) !== void 0) {
        var m;
        return O((m = _.values) === null || m === void 0 ? void 0 : m[d]);
      }
      let [h, s] = x(d);
      if (s !== void 0) {
        var y, f, k, S;
        let C = (S = (y = _.values) === null || y === void 0 ? void 0 : y[h]) !== null && S !== void 0 ? S : A(h) ? h.slice(1, -1) : void 0;
        return C === void 0 ? void 0 : (C = O(C), A(s) ? (0, u.withAlphaValue)(C, E(s)) : ((f = c.theme) === null || f === void 0 || (k = f.opacity) === null || k === void 0 ? void 0 : k[s]) === void 0 ? void 0 : (0, u.withAlphaValue)(C, c.theme.opacity[s]));
      }
      return g(d, _, {
        validate: o.color
      });
    }
    function R(d, _ = {}) {
      var c;
      return (c = _.values) === null || c === void 0 ? void 0 : c[d];
    }
    function T(d) {
      return (_, c) => g(_, c, {
        validate: d
      });
    }
    let F = {
      any: g,
      color: q,
      url: T(o.url),
      image: T(o.image),
      length: T(o.length),
      percentage: T(o.percentage),
      position: T(o.position),
      lookup: R,
      "generic-name": T(o.genericName),
      "family-name": T(o.familyName),
      number: T(o.number),
      "line-width": T(o.lineWidth),
      "absolute-size": T(o.absoluteSize),
      "relative-size": T(o.relativeSize),
      shadow: T(o.shadow),
      size: T(t.backgroundSize)
    }, L = Object.keys(F);
    function P(d, _) {
      let c = d.indexOf(_);
      return c === -1 ? [
        void 0,
        d
      ] : [
        d.slice(0, c),
        d.slice(c + 1)
      ];
    }
    function D(d, _, c, i) {
      if (c.values && _ in c.values)
        for (let { type: h } of d ?? []) {
          let s = F[h](_, c, {
            tailwindConfig: i
          });
          if (s !== void 0)
            return [
              s,
              h,
              null
            ];
        }
      if (A(_)) {
        let h = _.slice(1, -1), [s, y] = P(h, ":");
        if (!/^[\w-_]+$/g.test(s))
          y = h;
        else if (s !== void 0 && !L.includes(s))
          return [];
        if (y.length > 0 && L.includes(s))
          return [
            g(`[${y}]`, c),
            s,
            null
          ];
      }
      let m = z(d, _, c, i);
      for (let h of m)
        return h;
      return [];
    }
    function* z(d, _, c, i) {
      let m = (0, w.flagEnabled)(i, "generalizedModifiers"), [h, s] = x(_);
      if (m && c.modifiers != null && (c.modifiers === "any" || typeof c.modifiers == "object" && (s && A(s) || s in c.modifiers)) || (h = _, s = void 0), s !== void 0 && h === "" && (h = "DEFAULT"), s !== void 0 && typeof c.modifiers == "object") {
        var f, k;
        let S = (k = (f = c.modifiers) === null || f === void 0 ? void 0 : f[s]) !== null && k !== void 0 ? k : null;
        S !== null ? s = S : A(s) && (s = E(s));
      }
      for (let { type: S } of d ?? []) {
        let C = F[S](h, c, {
          tailwindConfig: i
        });
        C !== void 0 && (yield [
          C,
          S,
          s ?? null
        ]);
      }
    }
  })(Q)), Q;
}
var se = {}, Ve;
function Sr() {
  return Ve || (Ve = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return v;
      }
    });
    function v(n) {
      return typeof n == "function" ? n({}) : n;
    }
  })(se)), se;
}
var Ne;
function Er() {
  return Ne || (Ne = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return c;
      }
    });
    const v = /* @__PURE__ */ A(rr()), n = /* @__PURE__ */ A(gr()), u = /* @__PURE__ */ A(mr()), o = /* @__PURE__ */ A(hr()), a = vr(), t = br(), w = xr(), l = /* @__PURE__ */ A(yr()), r = wr(), p = Pr(), b = ar(), g = /* @__PURE__ */ A(Sr());
    function A(i) {
      return i && i.__esModule ? i : {
        default: i
      };
    }
    function x(i) {
      return typeof i == "function";
    }
    function O(i, ...m) {
      let h = m.pop();
      for (let s of m)
        for (let y in s) {
          let f = h(i[y], s[y]);
          f === void 0 ? (0, l.default)(i[y]) && (0, l.default)(s[y]) ? i[y] = O({}, i[y], s[y], h) : i[y] = s[y] : i[y] = f;
        }
      return i;
    }
    const E = {
      colors: o.default,
      negative(i) {
        return Object.keys(i).filter((m) => i[m] !== "0").reduce((m, h) => {
          let s = (0, v.default)(i[h]);
          return s !== void 0 && (m[`-${h}`] = s), m;
        }, {});
      },
      breakpoints(i) {
        return Object.keys(i).filter((m) => typeof i[m] == "string").reduce((m, h) => ({
          ...m,
          [`screen-${h}`]: i[h]
        }), {});
      }
    };
    function q(i, ...m) {
      return x(i) ? i(...m) : i;
    }
    function R(i) {
      return i.reduce((m, { extend: h }) => O(m, h, (s, y) => s === void 0 ? [
        y
      ] : Array.isArray(s) ? [
        y,
        ...s
      ] : [
        y,
        s
      ]), {});
    }
    function T(i) {
      return {
        ...i.reduce((m, h) => (0, a.defaults)(m, h), {}),
        // In order to resolve n config objects, we combine all of their `extend` properties
        // into arrays instead of objects so they aren't overridden.
        extend: R(i)
      };
    }
    function F(i, m) {
      if (Array.isArray(i) && (0, l.default)(i[0]))
        return i.concat(m);
      if (Array.isArray(m) && (0, l.default)(m[0]) && (0, l.default)(i))
        return [
          i,
          ...m
        ];
      if (Array.isArray(m))
        return m;
    }
    function L({ extend: i, ...m }) {
      return O(m, i, (h, s) => !x(h) && !s.some(x) ? O({}, h, ...s, F) : (y, f) => O({}, ...[
        h,
        ...s
      ].map((k) => q(k, y, f)), F));
    }
    function* P(i) {
      let m = (0, t.toPath)(i);
      if (m.length === 0 || (yield m, Array.isArray(i)))
        return;
      let h = /^(.*?)\s*\/\s*([^/]+)$/, s = i.match(h);
      if (s !== null) {
        let [, y, f] = s, k = (0, t.toPath)(y);
        k.alpha = f, yield k;
      }
    }
    function D(i) {
      const m = (h, s) => {
        for (const y of P(h)) {
          let f = 0, k = i;
          for (; k != null && f < y.length; )
            k = k[y[f++]], k = x(k) && (y.alpha === void 0 || f <= y.length - 1) ? k(m, E) : k;
          if (k !== void 0) {
            if (y.alpha !== void 0) {
              let S = (0, p.parseColorFormat)(k);
              return (0, b.withAlphaValue)(S, y.alpha, (0, g.default)(S));
            }
            return (0, l.default)(k) ? (0, r.cloneDeep)(k) : k;
          }
        }
        return s;
      };
      return Object.assign(m, {
        theme: m,
        ...E
      }), Object.keys(i).reduce((h, s) => (h[s] = x(i[s]) ? i[s](m, E) : i[s], h), {});
    }
    function z(i) {
      let m = [];
      return i.forEach((h) => {
        m = [
          ...m,
          h
        ];
        var s;
        const y = (s = h?.plugins) !== null && s !== void 0 ? s : [];
        y.length !== 0 && y.forEach((f) => {
          f.__isOptionsFunction && (f = f());
          var k;
          m = [
            ...m,
            ...z([
              (k = f?.config) !== null && k !== void 0 ? k : {}
            ])
          ];
        });
      }), m;
    }
    function d(i) {
      return [
        ...i
      ].reduceRight((h, s) => x(s) ? s({
        corePlugins: h
      }) : (0, u.default)(s, h), n.default);
    }
    function _(i) {
      return [
        ...i
      ].reduceRight((h, s) => [
        ...h,
        ...s
      ], []);
    }
    function c(i) {
      let m = [
        ...z(i),
        {
          prefix: "",
          important: !1,
          separator: ":"
        }
      ];
      var h, s;
      return (0, w.normalizeConfig)((0, a.defaults)({
        theme: D(L(T(m.map((y) => (h = y?.theme) !== null && h !== void 0 ? h : {})))),
        corePlugins: d(m.map((y) => y.corePlugins)),
        plugins: _(i.map((y) => (s = y?.plugins) !== null && s !== void 0 ? s : []))
      }, ...m));
    }
  })(B)), B;
}
var fe = {}, de, Ie;
function Tr() {
  return Ie || (Ie = 1, de = {
    content: [],
    presets: [],
    darkMode: "media",
    // or 'class'
    theme: {
      accentColor: ({ theme: e }) => ({
        ...e("colors"),
        auto: "auto"
      }),
      animation: {
        none: "none",
        spin: "spin 1s linear infinite",
        ping: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
        pulse: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
        bounce: "bounce 1s infinite"
      },
      aria: {
        busy: 'busy="true"',
        checked: 'checked="true"',
        disabled: 'disabled="true"',
        expanded: 'expanded="true"',
        hidden: 'hidden="true"',
        pressed: 'pressed="true"',
        readonly: 'readonly="true"',
        required: 'required="true"',
        selected: 'selected="true"'
      },
      aspectRatio: {
        auto: "auto",
        square: "1 / 1",
        video: "16 / 9"
      },
      backdropBlur: ({ theme: e }) => e("blur"),
      backdropBrightness: ({ theme: e }) => e("brightness"),
      backdropContrast: ({ theme: e }) => e("contrast"),
      backdropGrayscale: ({ theme: e }) => e("grayscale"),
      backdropHueRotate: ({ theme: e }) => e("hueRotate"),
      backdropInvert: ({ theme: e }) => e("invert"),
      backdropOpacity: ({ theme: e }) => e("opacity"),
      backdropSaturate: ({ theme: e }) => e("saturate"),
      backdropSepia: ({ theme: e }) => e("sepia"),
      backgroundColor: ({ theme: e }) => e("colors"),
      backgroundImage: {
        none: "none",
        "gradient-to-t": "linear-gradient(to top, var(--tw-gradient-stops))",
        "gradient-to-tr": "linear-gradient(to top right, var(--tw-gradient-stops))",
        "gradient-to-r": "linear-gradient(to right, var(--tw-gradient-stops))",
        "gradient-to-br": "linear-gradient(to bottom right, var(--tw-gradient-stops))",
        "gradient-to-b": "linear-gradient(to bottom, var(--tw-gradient-stops))",
        "gradient-to-bl": "linear-gradient(to bottom left, var(--tw-gradient-stops))",
        "gradient-to-l": "linear-gradient(to left, var(--tw-gradient-stops))",
        "gradient-to-tl": "linear-gradient(to top left, var(--tw-gradient-stops))"
      },
      backgroundOpacity: ({ theme: e }) => e("opacity"),
      backgroundPosition: {
        bottom: "bottom",
        center: "center",
        left: "left",
        "left-bottom": "left bottom",
        "left-top": "left top",
        right: "right",
        "right-bottom": "right bottom",
        "right-top": "right top",
        top: "top"
      },
      backgroundSize: {
        auto: "auto",
        cover: "cover",
        contain: "contain"
      },
      blur: {
        0: "0",
        none: "",
        sm: "4px",
        DEFAULT: "8px",
        md: "12px",
        lg: "16px",
        xl: "24px",
        "2xl": "40px",
        "3xl": "64px"
      },
      borderColor: ({ theme: e }) => ({
        ...e("colors"),
        DEFAULT: e("colors.gray.200", "currentColor")
      }),
      borderOpacity: ({ theme: e }) => e("opacity"),
      borderRadius: {
        none: "0px",
        sm: "0.125rem",
        DEFAULT: "0.25rem",
        md: "0.375rem",
        lg: "0.5rem",
        xl: "0.75rem",
        "2xl": "1rem",
        "3xl": "1.5rem",
        full: "9999px"
      },
      borderSpacing: ({ theme: e }) => ({
        ...e("spacing")
      }),
      borderWidth: {
        DEFAULT: "1px",
        0: "0px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      boxShadow: {
        sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
        DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
        md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
        lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
        xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
        "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
        inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
        none: "none"
      },
      boxShadowColor: ({ theme: e }) => e("colors"),
      brightness: {
        0: "0",
        50: ".5",
        75: ".75",
        90: ".9",
        95: ".95",
        100: "1",
        105: "1.05",
        110: "1.1",
        125: "1.25",
        150: "1.5",
        200: "2"
      },
      caretColor: ({ theme: e }) => e("colors"),
      colors: ({ colors: e }) => ({
        inherit: e.inherit,
        current: e.current,
        transparent: e.transparent,
        black: e.black,
        white: e.white,
        slate: e.slate,
        gray: e.gray,
        zinc: e.zinc,
        neutral: e.neutral,
        stone: e.stone,
        red: e.red,
        orange: e.orange,
        amber: e.amber,
        yellow: e.yellow,
        lime: e.lime,
        green: e.green,
        emerald: e.emerald,
        teal: e.teal,
        cyan: e.cyan,
        sky: e.sky,
        blue: e.blue,
        indigo: e.indigo,
        violet: e.violet,
        purple: e.purple,
        fuchsia: e.fuchsia,
        pink: e.pink,
        rose: e.rose
      }),
      columns: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        "3xs": "16rem",
        "2xs": "18rem",
        xs: "20rem",
        sm: "24rem",
        md: "28rem",
        lg: "32rem",
        xl: "36rem",
        "2xl": "42rem",
        "3xl": "48rem",
        "4xl": "56rem",
        "5xl": "64rem",
        "6xl": "72rem",
        "7xl": "80rem"
      },
      container: {},
      content: {
        none: "none"
      },
      contrast: {
        0: "0",
        50: ".5",
        75: ".75",
        100: "1",
        125: "1.25",
        150: "1.5",
        200: "2"
      },
      cursor: {
        auto: "auto",
        default: "default",
        pointer: "pointer",
        wait: "wait",
        text: "text",
        move: "move",
        help: "help",
        "not-allowed": "not-allowed",
        none: "none",
        "context-menu": "context-menu",
        progress: "progress",
        cell: "cell",
        crosshair: "crosshair",
        "vertical-text": "vertical-text",
        alias: "alias",
        copy: "copy",
        "no-drop": "no-drop",
        grab: "grab",
        grabbing: "grabbing",
        "all-scroll": "all-scroll",
        "col-resize": "col-resize",
        "row-resize": "row-resize",
        "n-resize": "n-resize",
        "e-resize": "e-resize",
        "s-resize": "s-resize",
        "w-resize": "w-resize",
        "ne-resize": "ne-resize",
        "nw-resize": "nw-resize",
        "se-resize": "se-resize",
        "sw-resize": "sw-resize",
        "ew-resize": "ew-resize",
        "ns-resize": "ns-resize",
        "nesw-resize": "nesw-resize",
        "nwse-resize": "nwse-resize",
        "zoom-in": "zoom-in",
        "zoom-out": "zoom-out"
      },
      divideColor: ({ theme: e }) => e("borderColor"),
      divideOpacity: ({ theme: e }) => e("borderOpacity"),
      divideWidth: ({ theme: e }) => e("borderWidth"),
      dropShadow: {
        sm: "0 1px 1px rgb(0 0 0 / 0.05)",
        DEFAULT: ["0 1px 2px rgb(0 0 0 / 0.1)", "0 1px 1px rgb(0 0 0 / 0.06)"],
        md: ["0 4px 3px rgb(0 0 0 / 0.07)", "0 2px 2px rgb(0 0 0 / 0.06)"],
        lg: ["0 10px 8px rgb(0 0 0 / 0.04)", "0 4px 3px rgb(0 0 0 / 0.1)"],
        xl: ["0 20px 13px rgb(0 0 0 / 0.03)", "0 8px 5px rgb(0 0 0 / 0.08)"],
        "2xl": "0 25px 25px rgb(0 0 0 / 0.15)",
        none: "0 0 #0000"
      },
      fill: ({ theme: e }) => ({
        none: "none",
        ...e("colors")
      }),
      flex: {
        1: "1 1 0%",
        auto: "1 1 auto",
        initial: "0 1 auto",
        none: "none"
      },
      flexBasis: ({ theme: e }) => ({
        auto: "auto",
        ...e("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        "1/12": "8.333333%",
        "2/12": "16.666667%",
        "3/12": "25%",
        "4/12": "33.333333%",
        "5/12": "41.666667%",
        "6/12": "50%",
        "7/12": "58.333333%",
        "8/12": "66.666667%",
        "9/12": "75%",
        "10/12": "83.333333%",
        "11/12": "91.666667%",
        full: "100%"
      }),
      flexGrow: {
        0: "0",
        DEFAULT: "1"
      },
      flexShrink: {
        0: "0",
        DEFAULT: "1"
      },
      fontFamily: {
        sans: [
          "ui-sans-serif",
          "system-ui",
          "sans-serif",
          '"Apple Color Emoji"',
          '"Segoe UI Emoji"',
          '"Segoe UI Symbol"',
          '"Noto Color Emoji"'
        ],
        serif: ["ui-serif", "Georgia", "Cambria", '"Times New Roman"', "Times", "serif"],
        mono: [
          "ui-monospace",
          "SFMono-Regular",
          "Menlo",
          "Monaco",
          "Consolas",
          '"Liberation Mono"',
          '"Courier New"',
          "monospace"
        ]
      },
      fontSize: {
        xs: ["0.75rem", { lineHeight: "1rem" }],
        sm: ["0.875rem", { lineHeight: "1.25rem" }],
        base: ["1rem", { lineHeight: "1.5rem" }],
        lg: ["1.125rem", { lineHeight: "1.75rem" }],
        xl: ["1.25rem", { lineHeight: "1.75rem" }],
        "2xl": ["1.5rem", { lineHeight: "2rem" }],
        "3xl": ["1.875rem", { lineHeight: "2.25rem" }],
        "4xl": ["2.25rem", { lineHeight: "2.5rem" }],
        "5xl": ["3rem", { lineHeight: "1" }],
        "6xl": ["3.75rem", { lineHeight: "1" }],
        "7xl": ["4.5rem", { lineHeight: "1" }],
        "8xl": ["6rem", { lineHeight: "1" }],
        "9xl": ["8rem", { lineHeight: "1" }]
      },
      fontWeight: {
        thin: "100",
        extralight: "200",
        light: "300",
        normal: "400",
        medium: "500",
        semibold: "600",
        bold: "700",
        extrabold: "800",
        black: "900"
      },
      gap: ({ theme: e }) => e("spacing"),
      gradientColorStops: ({ theme: e }) => e("colors"),
      gradientColorStopPositions: {
        "0%": "0%",
        "5%": "5%",
        "10%": "10%",
        "15%": "15%",
        "20%": "20%",
        "25%": "25%",
        "30%": "30%",
        "35%": "35%",
        "40%": "40%",
        "45%": "45%",
        "50%": "50%",
        "55%": "55%",
        "60%": "60%",
        "65%": "65%",
        "70%": "70%",
        "75%": "75%",
        "80%": "80%",
        "85%": "85%",
        "90%": "90%",
        "95%": "95%",
        "100%": "100%"
      },
      grayscale: {
        0: "0",
        DEFAULT: "100%"
      },
      gridAutoColumns: {
        auto: "auto",
        min: "min-content",
        max: "max-content",
        fr: "minmax(0, 1fr)"
      },
      gridAutoRows: {
        auto: "auto",
        min: "min-content",
        max: "max-content",
        fr: "minmax(0, 1fr)"
      },
      gridColumn: {
        auto: "auto",
        "span-1": "span 1 / span 1",
        "span-2": "span 2 / span 2",
        "span-3": "span 3 / span 3",
        "span-4": "span 4 / span 4",
        "span-5": "span 5 / span 5",
        "span-6": "span 6 / span 6",
        "span-7": "span 7 / span 7",
        "span-8": "span 8 / span 8",
        "span-9": "span 9 / span 9",
        "span-10": "span 10 / span 10",
        "span-11": "span 11 / span 11",
        "span-12": "span 12 / span 12",
        "span-full": "1 / -1"
      },
      gridColumnEnd: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridColumnStart: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridRow: {
        auto: "auto",
        "span-1": "span 1 / span 1",
        "span-2": "span 2 / span 2",
        "span-3": "span 3 / span 3",
        "span-4": "span 4 / span 4",
        "span-5": "span 5 / span 5",
        "span-6": "span 6 / span 6",
        "span-7": "span 7 / span 7",
        "span-8": "span 8 / span 8",
        "span-9": "span 9 / span 9",
        "span-10": "span 10 / span 10",
        "span-11": "span 11 / span 11",
        "span-12": "span 12 / span 12",
        "span-full": "1 / -1"
      },
      gridRowEnd: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridRowStart: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridTemplateColumns: {
        none: "none",
        subgrid: "subgrid",
        1: "repeat(1, minmax(0, 1fr))",
        2: "repeat(2, minmax(0, 1fr))",
        3: "repeat(3, minmax(0, 1fr))",
        4: "repeat(4, minmax(0, 1fr))",
        5: "repeat(5, minmax(0, 1fr))",
        6: "repeat(6, minmax(0, 1fr))",
        7: "repeat(7, minmax(0, 1fr))",
        8: "repeat(8, minmax(0, 1fr))",
        9: "repeat(9, minmax(0, 1fr))",
        10: "repeat(10, minmax(0, 1fr))",
        11: "repeat(11, minmax(0, 1fr))",
        12: "repeat(12, minmax(0, 1fr))"
      },
      gridTemplateRows: {
        none: "none",
        subgrid: "subgrid",
        1: "repeat(1, minmax(0, 1fr))",
        2: "repeat(2, minmax(0, 1fr))",
        3: "repeat(3, minmax(0, 1fr))",
        4: "repeat(4, minmax(0, 1fr))",
        5: "repeat(5, minmax(0, 1fr))",
        6: "repeat(6, minmax(0, 1fr))",
        7: "repeat(7, minmax(0, 1fr))",
        8: "repeat(8, minmax(0, 1fr))",
        9: "repeat(9, minmax(0, 1fr))",
        10: "repeat(10, minmax(0, 1fr))",
        11: "repeat(11, minmax(0, 1fr))",
        12: "repeat(12, minmax(0, 1fr))"
      },
      height: ({ theme: e }) => ({
        auto: "auto",
        ...e("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        full: "100%",
        screen: "100vh",
        svh: "100svh",
        lvh: "100lvh",
        dvh: "100dvh",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      hueRotate: {
        0: "0deg",
        15: "15deg",
        30: "30deg",
        60: "60deg",
        90: "90deg",
        180: "180deg"
      },
      inset: ({ theme: e }) => ({
        auto: "auto",
        ...e("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        full: "100%"
      }),
      invert: {
        0: "0",
        DEFAULT: "100%"
      },
      keyframes: {
        spin: {
          to: {
            transform: "rotate(360deg)"
          }
        },
        ping: {
          "75%, 100%": {
            transform: "scale(2)",
            opacity: "0"
          }
        },
        pulse: {
          "50%": {
            opacity: ".5"
          }
        },
        bounce: {
          "0%, 100%": {
            transform: "translateY(-25%)",
            animationTimingFunction: "cubic-bezier(0.8,0,1,1)"
          },
          "50%": {
            transform: "none",
            animationTimingFunction: "cubic-bezier(0,0,0.2,1)"
          }
        }
      },
      letterSpacing: {
        tighter: "-0.05em",
        tight: "-0.025em",
        normal: "0em",
        wide: "0.025em",
        wider: "0.05em",
        widest: "0.1em"
      },
      lineHeight: {
        none: "1",
        tight: "1.25",
        snug: "1.375",
        normal: "1.5",
        relaxed: "1.625",
        loose: "2",
        3: ".75rem",
        4: "1rem",
        5: "1.25rem",
        6: "1.5rem",
        7: "1.75rem",
        8: "2rem",
        9: "2.25rem",
        10: "2.5rem"
      },
      listStyleType: {
        none: "none",
        disc: "disc",
        decimal: "decimal"
      },
      listStyleImage: {
        none: "none"
      },
      margin: ({ theme: e }) => ({
        auto: "auto",
        ...e("spacing")
      }),
      lineClamp: {
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6"
      },
      maxHeight: ({ theme: e }) => ({
        ...e("spacing"),
        none: "none",
        full: "100%",
        screen: "100vh",
        svh: "100svh",
        lvh: "100lvh",
        dvh: "100dvh",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      maxWidth: ({ theme: e, breakpoints: v }) => ({
        ...e("spacing"),
        none: "none",
        xs: "20rem",
        sm: "24rem",
        md: "28rem",
        lg: "32rem",
        xl: "36rem",
        "2xl": "42rem",
        "3xl": "48rem",
        "4xl": "56rem",
        "5xl": "64rem",
        "6xl": "72rem",
        "7xl": "80rem",
        full: "100%",
        min: "min-content",
        max: "max-content",
        fit: "fit-content",
        prose: "65ch",
        ...v(e("screens"))
      }),
      minHeight: ({ theme: e }) => ({
        ...e("spacing"),
        full: "100%",
        screen: "100vh",
        svh: "100svh",
        lvh: "100lvh",
        dvh: "100dvh",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      minWidth: ({ theme: e }) => ({
        ...e("spacing"),
        full: "100%",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      objectPosition: {
        bottom: "bottom",
        center: "center",
        left: "left",
        "left-bottom": "left bottom",
        "left-top": "left top",
        right: "right",
        "right-bottom": "right bottom",
        "right-top": "right top",
        top: "top"
      },
      opacity: {
        0: "0",
        5: "0.05",
        10: "0.1",
        15: "0.15",
        20: "0.2",
        25: "0.25",
        30: "0.3",
        35: "0.35",
        40: "0.4",
        45: "0.45",
        50: "0.5",
        55: "0.55",
        60: "0.6",
        65: "0.65",
        70: "0.7",
        75: "0.75",
        80: "0.8",
        85: "0.85",
        90: "0.9",
        95: "0.95",
        100: "1"
      },
      order: {
        first: "-9999",
        last: "9999",
        none: "0",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12"
      },
      outlineColor: ({ theme: e }) => e("colors"),
      outlineOffset: {
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      outlineWidth: {
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      padding: ({ theme: e }) => e("spacing"),
      placeholderColor: ({ theme: e }) => e("colors"),
      placeholderOpacity: ({ theme: e }) => e("opacity"),
      ringColor: ({ theme: e }) => ({
        DEFAULT: e("colors.blue.500", "#3b82f6"),
        ...e("colors")
      }),
      ringOffsetColor: ({ theme: e }) => e("colors"),
      ringOffsetWidth: {
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      ringOpacity: ({ theme: e }) => ({
        DEFAULT: "0.5",
        ...e("opacity")
      }),
      ringWidth: {
        DEFAULT: "3px",
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      rotate: {
        0: "0deg",
        1: "1deg",
        2: "2deg",
        3: "3deg",
        6: "6deg",
        12: "12deg",
        45: "45deg",
        90: "90deg",
        180: "180deg"
      },
      saturate: {
        0: "0",
        50: ".5",
        100: "1",
        150: "1.5",
        200: "2"
      },
      scale: {
        0: "0",
        50: ".5",
        75: ".75",
        90: ".9",
        95: ".95",
        100: "1",
        105: "1.05",
        110: "1.1",
        125: "1.25",
        150: "1.5"
      },
      screens: {
        sm: "640px",
        md: "768px",
        lg: "1024px",
        xl: "1280px",
        "2xl": "1536px"
      },
      scrollMargin: ({ theme: e }) => ({
        ...e("spacing")
      }),
      scrollPadding: ({ theme: e }) => e("spacing"),
      sepia: {
        0: "0",
        DEFAULT: "100%"
      },
      skew: {
        0: "0deg",
        1: "1deg",
        2: "2deg",
        3: "3deg",
        6: "6deg",
        12: "12deg"
      },
      space: ({ theme: e }) => ({
        ...e("spacing")
      }),
      spacing: {
        px: "1px",
        0: "0px",
        0.5: "0.125rem",
        1: "0.25rem",
        1.5: "0.375rem",
        2: "0.5rem",
        2.5: "0.625rem",
        3: "0.75rem",
        3.5: "0.875rem",
        4: "1rem",
        5: "1.25rem",
        6: "1.5rem",
        7: "1.75rem",
        8: "2rem",
        9: "2.25rem",
        10: "2.5rem",
        11: "2.75rem",
        12: "3rem",
        14: "3.5rem",
        16: "4rem",
        20: "5rem",
        24: "6rem",
        28: "7rem",
        32: "8rem",
        36: "9rem",
        40: "10rem",
        44: "11rem",
        48: "12rem",
        52: "13rem",
        56: "14rem",
        60: "15rem",
        64: "16rem",
        72: "18rem",
        80: "20rem",
        96: "24rem"
      },
      stroke: ({ theme: e }) => ({
        none: "none",
        ...e("colors")
      }),
      strokeWidth: {
        0: "0",
        1: "1",
        2: "2"
      },
      supports: {},
      data: {},
      textColor: ({ theme: e }) => e("colors"),
      textDecorationColor: ({ theme: e }) => e("colors"),
      textDecorationThickness: {
        auto: "auto",
        "from-font": "from-font",
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      textIndent: ({ theme: e }) => ({
        ...e("spacing")
      }),
      textOpacity: ({ theme: e }) => e("opacity"),
      textUnderlineOffset: {
        auto: "auto",
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      transformOrigin: {
        center: "center",
        top: "top",
        "top-right": "top right",
        right: "right",
        "bottom-right": "bottom right",
        bottom: "bottom",
        "bottom-left": "bottom left",
        left: "left",
        "top-left": "top left"
      },
      transitionDelay: {
        0: "0s",
        75: "75ms",
        100: "100ms",
        150: "150ms",
        200: "200ms",
        300: "300ms",
        500: "500ms",
        700: "700ms",
        1e3: "1000ms"
      },
      transitionDuration: {
        DEFAULT: "150ms",
        0: "0s",
        75: "75ms",
        100: "100ms",
        150: "150ms",
        200: "200ms",
        300: "300ms",
        500: "500ms",
        700: "700ms",
        1e3: "1000ms"
      },
      transitionProperty: {
        none: "none",
        all: "all",
        DEFAULT: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
        colors: "color, background-color, border-color, text-decoration-color, fill, stroke",
        opacity: "opacity",
        shadow: "box-shadow",
        transform: "transform"
      },
      transitionTimingFunction: {
        DEFAULT: "cubic-bezier(0.4, 0, 0.2, 1)",
        linear: "linear",
        in: "cubic-bezier(0.4, 0, 1, 1)",
        out: "cubic-bezier(0, 0, 0.2, 1)",
        "in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
      },
      translate: ({ theme: e }) => ({
        ...e("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        full: "100%"
      }),
      size: ({ theme: e }) => ({
        auto: "auto",
        ...e("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        "1/12": "8.333333%",
        "2/12": "16.666667%",
        "3/12": "25%",
        "4/12": "33.333333%",
        "5/12": "41.666667%",
        "6/12": "50%",
        "7/12": "58.333333%",
        "8/12": "66.666667%",
        "9/12": "75%",
        "10/12": "83.333333%",
        "11/12": "91.666667%",
        full: "100%",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      width: ({ theme: e }) => ({
        auto: "auto",
        ...e("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        "1/12": "8.333333%",
        "2/12": "16.666667%",
        "3/12": "25%",
        "4/12": "33.333333%",
        "5/12": "41.666667%",
        "6/12": "50%",
        "7/12": "58.333333%",
        "8/12": "66.666667%",
        "9/12": "75%",
        "10/12": "83.333333%",
        "11/12": "91.666667%",
        full: "100%",
        screen: "100vw",
        svw: "100svw",
        lvw: "100lvw",
        dvw: "100dvw",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      willChange: {
        auto: "auto",
        scroll: "scroll-position",
        contents: "contents",
        transform: "transform"
      },
      zIndex: {
        auto: "auto",
        0: "0",
        10: "10",
        20: "20",
        30: "30",
        40: "40",
        50: "50"
      }
    },
    plugins: []
  }), de;
}
var He;
function Dr() {
  return He || (He = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const v = /* @__PURE__ */ u(Tr()), n = be();
    function u(a) {
      return a && a.__esModule ? a : {
        default: a
      };
    }
    function o(a) {
      var t;
      const w = ((t = a?.presets) !== null && t !== void 0 ? t : [
        v.default
      ]).slice().reverse().flatMap((p) => o(p instanceof Function ? p() : p)), l = {
        // Add experimental configs here...
        respectDefaultRingColorOpacity: {
          theme: {
            ringColor: ({ theme: p }) => ({
              DEFAULT: "#3b82f67f",
              ...p("colors")
            })
          }
        },
        disableColorOpacityUtilitiesByDefault: {
          corePlugins: {
            backgroundOpacity: !1,
            borderOpacity: !1,
            divideOpacity: !1,
            placeholderOpacity: !1,
            ringOpacity: !1,
            textOpacity: !1
          }
        }
      }, r = Object.keys(l).filter((p) => (0, n.flagEnabled)(a, p)).map((p) => l[p]);
      return [
        a,
        ...r,
        ...w
      ];
    }
  })(fe)), fe;
}
var Ge;
function qr() {
  return Ge || (Ge = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const v = /* @__PURE__ */ u(Er()), n = /* @__PURE__ */ u(Dr());
    function u(a) {
      return a && a.__esModule ? a : {
        default: a
      };
    }
    function o(...a) {
      let [, ...t] = (0, n.default)(a[0]);
      return (0, v.default)([
        ...a,
        ...t
      ]);
    }
  })(U)), U;
}
var ce, Ye;
function Rr() {
  if (Ye) return ce;
  Ye = 1;
  let e = qr();
  return ce = (e.__esModule ? e : { default: e }).default, ce;
}
var Fr = Rr();
const zr = /* @__PURE__ */ er(Fr), Xe = {
  safelist: [{ pattern: /text-.*/ }],
  theme: {
    colors: {
      background: "hsl(var(--background))",
      foreground: "hsl(var(--foreground))",
      "branded-background": "hsl(var(--branded-background))",
      "branded-foreground": "hsl(var(--branded-foreground))",
      "foreground-color": "hsl(var(--background))",
      primary: {
        foreground: "hsl(var(--primary-foreground))",
        "foreground-color": "hsl(var(--primary))",
        "foreground-dark": "hsl(var(--primary-dark))",
        DEFAULT: "hsl(var(--primary))",
        hover: "hsl(var(--primary-dark))",
        dark: "hsl(var(--primary-dark))",
        light: "hsl(var(--primary-light))"
      },
      secondary: {
        foreground: "hsl(var(--secondary-foreground))",
        "foreground-color": "hsl(var(--secondary))",
        "foreground-dark": "hsl(var(--secondary-dark))",
        DEFAULT: "hsl(var(--secondary))",
        hover: "hsl(var(--secondary-dark))",
        dark: "hsl(var(--secondary-dark))",
        light: "hsl(var(--secondary-light))"
      },
      tertiary: {
        foreground: "hsl(var(--tertiary-foreground))",
        "foreground-color": "hsl(var(--tertiary))",
        "foreground-dark": "hsl(var(--tertiary-dark))",
        DEFAULT: "hsl(var(--tertiary))",
        hover: "hsl(var(--tertiary-dark))",
        dark: "hsl(var(--tertiary-dark))",
        light: "hsl(var(--tertiary-light))"
      },
      success: {
        foreground: "hsl(var(--success-foreground))",
        "foreground-color": "hsl(var(--success))",
        "foreground-dark": "hsl(var(--success-dark))",
        light: "hsl(var(--success-light))",
        DEFAULT: "hsl(var(--success))",
        hover: "hsl(var(--success-dark))",
        dark: "hsl(var(--success-dark))"
      },
      info: {
        foreground: "hsl(var(--info-foreground))",
        "foreground-color": "hsl(var(--info))",
        "foreground-dark": "hsl(var(--info-dark))",
        light: "hsl(var(--info-light))",
        DEFAULT: "hsl(var(--info))",
        hover: "hsl(var(--info-dark))",
        dark: "hsl(var(--info-dark))"
      },
      warning: {
        foreground: "hsl(var(--warning-foreground))",
        "foreground-color": "hsl(var(--warning))",
        "foreground-dark": "hsl(var(--warning-dark))",
        light: "hsl(var(--warning-light))",
        DEFAULT: "hsl(var(--warning))",
        hover: "hsl(var(--warning-dark))",
        dark: "hsl(var(--warning-dark))"
      },
      destructive: {
        foreground: "hsl(var(--destructive-foreground))",
        "foreground-color": "hsl(var(--destructive))",
        "foreground-dark": "hsl(var(--destructive-dark))",
        light: "hsl(var(--destructive-light))",
        DEFAULT: "hsl(var(--destructive))",
        hover: "hsl(var(--destructive-hover))",
        dark: "hsl(var(--destructive-dark))"
      },
      runkeeper: {
        foreground: "hsl(var(--white))",
        "foreground-color": "hsl(var(--runkeeper))",
        light: "",
        DEFAULT: "hsl(var(--runkeeper))",
        hover: "",
        dark: ""
      },
      white: "hsl(var(--white))",
      gray: {
        foreground: "hsl(var(--gray-900))",
        "foreground-color": "hsl(var(--gray-100))",
        "foreground-dark": "hsl(var(--gray-900))",
        light: "hsl(var(--gray-10))",
        DEFAULT: "hsl(var(--gray-100))",
        hover: "hsl(var(--gray-600))",
        dark: "hsl(var(--gray-900))",
        100: "hsl(var(--gray-10))",
        200: "hsl(var(--gray-30))",
        300: "hsl(var(--gray-50))",
        400: "hsl(var(--gray-100))",
        500: "hsl(var(--gray-200))",
        600: "hsl(var(--gray-300))",
        700: "hsl(var(--gray-600))",
        800: "hsl(var(--gray-700))",
        900: "hsl(var(--gray-900))"
      },
      light: "hsl(var(--light))",
      dark: "hsl(var(--dark))",
      black: "hsl(var(--black))",
      menuBg: "hsl(var(--menu-bg))",
      transparent: "hsla(var(--transparent))",
      accent: "hsl(var(--accent))",
      "accent-foreground": "hsl(var(--accent-foreground))",
      ai: {
        "gradient-start": "hsl(var(--ai-gradient-start))",
        "gradient-middle": "hsl(var(--ai-gradient-middle))",
        "gradient-end": "hsl(var(--ai-gradient-end))",
        foreground: "hsl(var(--ai-foreground))"
      },
      muted: "hsl(var(--muted))",
      "muted-foreground": "hsl(var(--muted-foreground))",
      skeleton: {
        100: "hsl(var(--skeleton-100))",
        200: "hsl(var(--skeleton-200))",
        300: "hsl(var(--skeleton-300))",
        400: "hsl(var(--skeleton-400))"
      },
      border: "hsl(var(--border))",
      chart: {
        aqua: "hsl(var(--chart-aqua))",
        yellow: "hsl(var(--chart-yellow))",
        blue: "hsl(var(--chart-blue))",
        purple: "hsl(var(--chart-purple))",
        orange: "hsl(var(--chart-orange))",
        green: "hsl(var(--chart-green))",
        pink: "hsl(var(--chart-pink))",
        teal: "hsl(var(--chart-teal))",
        red: "hsl(var(--chart-red))"
      }
    },
    spacing: {
      0: "0px",
      1: "1px",
      2: "2px",
      3: "4px",
      4: "8px",
      5: "12px",
      6: "16px",
      7: "24px",
      8: "32px",
      9: "36px",
      // to align with shadCn styles
      10: "40px",
      // to align with shadCn styles
      11: "44px"
      // to align with shadCn styles
    },
    fontFamily: {
      sans: ["Open Sans", "Noto Sans JP", "Noto Sans Thai", "sans-serif"],
      montserrat: ["Montserrat", "sans-serif"],
      "permanent-marker": ["Permanent Marker", "cursive"]
    },
    fontWeight: {
      medium: "400",
      semibold: "600",
      bold: "700"
    },
    fontSize: {
      display: "var(--font-display)",
      "3xl": "var(--font-3xl)",
      "2xl": "var(--font-2xl)",
      xl: "var(--font-xl)",
      lg: "var(--font-lg)",
      base: "inherit",
      md: "var(--font-md)",
      sm: "var(--font-sm)"
    },
    screens: {
      sm: "576px",
      md: "768px",
      lg: "992px",
      xl: "1200px",
      "2xl": "1440px"
    },
    extend: {
      boxShadow: {
        DEFAULT: "0 2px 4px 0 hsla(0, 0%, 10%, 0.06)",
        button: "0 2px 4px 0 hsla(0, 0%, 0%, 0.08)",
        floating: "0 2px 8px 0 hsla(0, 0%, 10%, 0.16)"
      },
      colors: {
        background: "hsl(var(--background))",
        foreground: "hsl(var(--foreground))",
        popover: {
          DEFAULT: "hsl(var(--popover))",
          foreground: "hsl(var(--popover-foreground))"
        },
        card: {
          DEFAULT: "hsl(var(--card))",
          foreground: "hsl(var(--card-foreground))"
        },
        checkbox: {
          DEFAULT: "hsl(var(--checkbox-checked-bg))",
          foreground: "hsl(var(--checkbox-checked-foreground))"
        },
        "proportion-bar-on-course": "hsl(var(--proportion-bar-on-course))",
        "proportion-bar-finished": "hsl(var(--proportion-bar-finished))"
      },
      zIndex: {
        1: "1",
        2: "2",
        // Floating chrome (AI chat launcher) sits above sticky page UI (z-10) and below
        // dialogs, sheets, and popovers (z-50).
        floating: "40"
      },
      keyframes: {
        "accordion-down": {
          from: { height: "0" },
          to: { height: "var(--radix-accordion-content-height)" }
        },
        "accordion-up": {
          from: { height: "var(--radix-accordion-content-height)" },
          to: { height: "0" }
        }
      },
      animation: {
        "accordion-down": "accordion-down 0.2s ease-out",
        "accordion-up": "accordion-up 0.2s ease-out"
      },
      backgroundImage: {
        "proportion-bar-on-course-stripe": "var(--proportion-bar-on-course-stripe-image)"
      }
    }
  }
};
var pe = {}, ge = {}, Ke;
function Lr() {
  return Ke || (Ke = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    function v(u, o) {
      return {
        handler: u,
        config: o
      };
    }
    v.withOptions = function(u, o = () => ({})) {
      const a = function(t) {
        return {
          __options: t,
          handler: u(t),
          config: o(t)
        };
      };
      return a.__isOptionsFunction = !0, a.__pluginFunction = u, a.__configFunction = o, a;
    };
    const n = v;
  })(ge)), ge;
}
var Je;
function Mr() {
  return Je || (Je = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return u;
      }
    });
    const v = /* @__PURE__ */ n(Lr());
    function n(o) {
      return o && o.__esModule ? o : {
        default: o
      };
    }
    const u = v.default;
  })(pe)), pe;
}
var me, Ze;
function $r() {
  if (Ze) return me;
  Ze = 1;
  let e = Mr();
  return me = (e.__esModule ? e : { default: e }).default, me;
}
var he, Qe;
function jr() {
  if (Qe) return he;
  Qe = 1;
  const e = $r();
  function v(n) {
    return Object.fromEntries(
      Object.entries(n).filter(([u]) => u !== "DEFAULT")
    );
  }
  return he = e(
    ({ addUtilities: n, matchUtilities: u, theme: o }) => {
      n({
        "@keyframes enter": o("keyframes.enter"),
        "@keyframes exit": o("keyframes.exit"),
        ".animate-in": {
          animationName: "enter",
          animationDuration: o("animationDuration.DEFAULT"),
          "--tw-enter-opacity": "initial",
          "--tw-enter-scale": "initial",
          "--tw-enter-rotate": "initial",
          "--tw-enter-translate-x": "initial",
          "--tw-enter-translate-y": "initial"
        },
        ".animate-out": {
          animationName: "exit",
          animationDuration: o("animationDuration.DEFAULT"),
          "--tw-exit-opacity": "initial",
          "--tw-exit-scale": "initial",
          "--tw-exit-rotate": "initial",
          "--tw-exit-translate-x": "initial",
          "--tw-exit-translate-y": "initial"
        }
      }), u(
        {
          "fade-in": (a) => ({ "--tw-enter-opacity": a }),
          "fade-out": (a) => ({ "--tw-exit-opacity": a })
        },
        { values: o("animationOpacity") }
      ), u(
        {
          "zoom-in": (a) => ({ "--tw-enter-scale": a }),
          "zoom-out": (a) => ({ "--tw-exit-scale": a })
        },
        { values: o("animationScale") }
      ), u(
        {
          "spin-in": (a) => ({ "--tw-enter-rotate": a }),
          "spin-out": (a) => ({ "--tw-exit-rotate": a })
        },
        { values: o("animationRotate") }
      ), u(
        {
          "slide-in-from-top": (a) => ({
            "--tw-enter-translate-y": `-${a}`
          }),
          "slide-in-from-bottom": (a) => ({
            "--tw-enter-translate-y": a
          }),
          "slide-in-from-left": (a) => ({
            "--tw-enter-translate-x": `-${a}`
          }),
          "slide-in-from-right": (a) => ({
            "--tw-enter-translate-x": a
          }),
          "slide-out-to-top": (a) => ({
            "--tw-exit-translate-y": `-${a}`
          }),
          "slide-out-to-bottom": (a) => ({
            "--tw-exit-translate-y": a
          }),
          "slide-out-to-left": (a) => ({
            "--tw-exit-translate-x": `-${a}`
          }),
          "slide-out-to-right": (a) => ({
            "--tw-exit-translate-x": a
          })
        },
        { values: o("animationTranslate") }
      ), u(
        { duration: (a) => ({ animationDuration: a }) },
        { values: v(o("animationDuration")) }
      ), u(
        { delay: (a) => ({ animationDelay: a }) },
        { values: o("animationDelay") }
      ), u(
        { ease: (a) => ({ animationTimingFunction: a }) },
        { values: v(o("animationTimingFunction")) }
      ), n({
        ".running": { animationPlayState: "running" },
        ".paused": { animationPlayState: "paused" }
      }), u(
        { "fill-mode": (a) => ({ animationFillMode: a }) },
        { values: o("animationFillMode") }
      ), u(
        { direction: (a) => ({ animationDirection: a }) },
        { values: o("animationDirection") }
      ), u(
        { repeat: (a) => ({ animationIterationCount: a }) },
        { values: o("animationRepeat") }
      );
    },
    {
      theme: {
        extend: {
          animationDelay: ({ theme: n }) => ({
            ...n("transitionDelay")
          }),
          animationDuration: ({ theme: n }) => ({
            0: "0ms",
            ...n("transitionDuration")
          }),
          animationTimingFunction: ({ theme: n }) => ({
            ...n("transitionTimingFunction")
          }),
          animationFillMode: {
            none: "none",
            forwards: "forwards",
            backwards: "backwards",
            both: "both"
          },
          animationDirection: {
            normal: "normal",
            reverse: "reverse",
            alternate: "alternate",
            "alternate-reverse": "alternate-reverse"
          },
          animationOpacity: ({ theme: n }) => ({
            DEFAULT: 0,
            ...n("opacity")
          }),
          animationTranslate: ({ theme: n }) => ({
            DEFAULT: "100%",
            ...n("translate")
          }),
          animationScale: ({ theme: n }) => ({
            DEFAULT: 0,
            ...n("scale")
          }),
          animationRotate: ({ theme: n }) => ({
            DEFAULT: "30deg",
            ...n("rotate")
          }),
          animationRepeat: {
            0: "0",
            1: "1",
            infinite: "infinite"
          },
          keyframes: {
            enter: {
              from: {
                opacity: "var(--tw-enter-opacity, 1)",
                transform: "translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0))"
              }
            },
            exit: {
              to: {
                opacity: "var(--tw-exit-opacity, 1)",
                transform: "translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0))"
              }
            }
          }
        }
      }
    }
  ), he;
}
var Ur = jr();
const Br = /* @__PURE__ */ er(Ur), Wr = {
  presets: [Xe],
  safelist: [
    ...Xe?.safelist ?? [],
    {
      pattern: /(mt|mb|ml|mr|gap|gap-x|gap-y|col-span)-([0-9])/,
      variants: ["md"]
    },
    {
      pattern: /ml-auto/,
      variants: ["md"]
    },
    {
      pattern: /grid-cols-([0-9])/,
      variants: ["sm", "md", "lg"]
    },
    {
      pattern: /auto-cols-/
    },
    {
      pattern: /(-)?(right-|bottom-)/
    },
    {
      pattern: /(justify-center|justify-start)/,
      variants: ["sm", "md", "lg"]
    },
    { pattern: /--color-chart/ },
    // hardcoded classes that we need
    "line-through",
    "break-words",
    "w-[64px]",
    "w-[171px]",
    "w-[300px]",
    "w-[320px]",
    "min-w-[320px]",
    "max-w-[380px]",
    "max-w-[576px]",
    "md:w-auto",
    "min-w-fit",
    "p-2",
    "pb-6",
    "lg:p-0",
    "lg:min-w-0",
    "h-[48px]",
    "h-[400px]",
    "md:flex-1",
    "items-stretch",
    "md:flex-wrap",
    "md:overflow-x-visible",
    "auto-cols-[320px]",
    "grid-flow-col",
    "md:grid-flow-row",
    "md:grid-cols-[repeat(3,minmax(0,380px))]",
    // Content block classes
    "[&_ul]:list-disc",
    "[&_ul]:ml-7",
    "[&_ul]:my-7",
    "[&_ul>li]:mt-2",
    "[&_ol]:list-decimal",
    "[&_ol]:ml-7",
    "[&_ol]:my-7",
    "[&_ol>li]:mt-2",
    "[&_img]:mx-auto",
    "[&_img]:block",
    "[&_blockquote]:mt-6",
    "[&_blockquote]:border-l-2",
    "[&_blockquote]:pl-6",
    "[&_blockquote]:italic",
    "[&_table]:w-full",
    "[&_table]:caption-bottom",
    "[&_table]:text-sm",
    "[&_caption]:text-muted-foreground",
    "[&_caption]:mt-4",
    "[&_caption]:text-sm",
    "[&_thead]:border-b",
    "[&_tbody>tr:last-child]:border-0",
    "[&_tr]:border-b",
    "[&_tr]:border-gray",
    "[&_tr:hover]:bg-muted",
    "[&_tr:hover]:bg-opacity-50",
    "[&_tr]:transition-colors",
    "[&_th]:text-muted-foreground",
    "[&_th]:font-semibold",
    "[&_th]:p-6",
    "[&_th]:text-left",
    "[&_th]:align-middle",
    "[&_th]:whitespace-nowrap",
    "[&_td]:p-6",
    "[&_td]:font-inherit",
    "[&_td]:text-inherit",
    "[&_td]:align-middle",
    "[&_td]:whitespace-nowrap",
    {
      pattern: /(bg-gray)-(100|200|300|400)/
    },
    {
      pattern: /(bg-skeleton)-(100|200|300|400)/
    },
    {
      pattern: /line-clamp-(\d+)/,
      variants: ["sm", "md", "lg", "xl", "2xl"]
    },
    {
      pattern: /text-(xs|sm|base|lg|xl|2xl)/
    },
    {
      pattern: /grid|w-full|object-contain/,
      variants: ["md", "lg"]
    },
    {
      pattern: /overflow(-(x|y))?-(auto|hidden|visible)/,
      variants: ["md", "lg"]
    }
  ],
  darkMode: ["class"],
  content: ["./src/**/*.{ts,tsx,mdx}", "./app/**/*.{ts,tsx,mdx}", "./components/**/*.{ts,tsx,mdx}"],
  plugins: [Br],
  theme: {
    extend: {
      keyframes: {
        "accordion-down": {
          from: {
            height: "0"
          },
          to: {
            height: "var(--radix-accordion-content-height)"
          }
        },
        "accordion-up": {
          from: {
            height: "var(--radix-accordion-content-height)"
          },
          to: {
            height: "0"
          }
        }
      },
      animation: {
        "accordion-down": "accordion-down 0.2s ease-out",
        "accordion-up": "accordion-up 0.2s ease-out"
      }
    }
  }
}, Vr = zr(Wr), Nr = Vr?.theme?.screens, or = sr({
  is2XL: !1,
  isXL: !1,
  isLG: !1,
  isMD: !1,
  isSM: !1,
  isMobile: !1,
  isPortrait: !1
}), Xr = ({ children: e }) => {
  const [, v] = fr({
    width: window.innerWidth,
    height: window.innerHeight
  }), n = dr(() => {
    v({ width: window.innerWidth, height: window.innerHeight });
  }, []);
  cr(() => (window.addEventListener("resize", n), () => window.removeEventListener("resize", n)), [n]);
  const u = ye(() => Object.entries(Nr).reduce(
    (g, [A, x]) => (g[A] = parseInt(`${x}`.replace("px", "")), g),
    {}
  ), []), o = $({ query: `(max-width: ${u.sm - 1}px)` }), a = $({
    query: `(min-width: ${u.sm}px)`
  }), t = $({
    query: `(min-width: ${u.md}px)`
  }), w = $({
    query: `(min-width: ${u.lg}px)`
  }), l = $({
    query: `(min-width: ${u.xl}px)`
  }), r = $({
    query: `(min-width: ${u["2xl"]}px)`
  }), p = $({ query: "(orientation: portrait)" }), b = ye(() => ({
    is2XL: r,
    isXL: l,
    isLG: w,
    isMD: t,
    isSM: a,
    isPortrait: p,
    isMobile: o
  }), [r, l, w, t, a, p, o]);
  return /* @__PURE__ */ ur.jsx(or.Provider, { value: b, children: e });
}, Kr = () => pr(or);
export {
  Xr as R,
  Kr as u
};
